// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, ServerSentEventsResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AdminCreateInvitationData, AdminCreateInvitationErrors, AdminCreateInvitationResponses, AdminDeleteFeedbackData, AdminDeleteFeedbackErrors, AdminDeleteFeedbackResponses, AdminFeedbackSummaryData, AdminFeedbackSummaryErrors, AdminFeedbackSummaryResponses, AdminGetFeedbackData, AdminGetFeedbackErrors, AdminGetFeedbackResponses, AdminGetFeedbackScreenshotData, AdminGetFeedbackScreenshotErrors, AdminGetFeedbackScreenshotResponses, AdminGetSettingsData, AdminGetSettingsErrors, AdminGetSettingsResponses, AdminGetUserData, AdminGetUserErrors, AdminGetUserResponses, AdminListAuthEventsData, AdminListAuthEventsErrors, AdminListAuthEventsResponses, AdminListFeedbackData, AdminListFeedbackErrors, AdminListFeedbackResponses, AdminListInvitationsData, AdminListInvitationsErrors, AdminListInvitationsResponses, AdminListSettingsHistoryData, AdminListSettingsHistoryErrors, AdminListSettingsHistoryResponses, AdminListUsersData, AdminListUsersErrors, AdminListUsersResponses, AdminResendInvitationData, AdminResendInvitationErrors, AdminResendInvitationResponses, AdminResetUserMfaData, AdminResetUserMfaErrors, AdminResetUserMfaResponses, AdminRevokeInvitationData, AdminRevokeInvitationErrors, AdminRevokeInvitationResponses, AdminRevokeUserSessionsData, AdminRevokeUserSessionsErrors, AdminRevokeUserSessionsResponses, AdminSendPasswordResetData, AdminSendPasswordResetErrors, AdminSendPasswordResetResponses, AdminSetAssistantBudgetData, AdminSetAssistantBudgetErrors, AdminSetAssistantBudgetResponses, AdminUpdateFeedbackData, AdminUpdateFeedbackErrors, AdminUpdateFeedbackResponses, AdminUpdateSettingsData, AdminUpdateSettingsErrors, AdminUpdateSettingsResponses, AdminUpdateUserData, AdminUpdateUserErrors, AdminUpdateUserResponses, AssessmentsApproveAssessmentData, AssessmentsApproveAssessmentErrors, AssessmentsApproveAssessmentResponses, AssessmentsCreateAssessmentData, AssessmentsCreateAssessmentErrors, AssessmentsCreateAssessmentResponses, AssessmentsDeleteAssessmentData, AssessmentsDeleteAssessmentErrors, AssessmentsDeleteAssessmentResponses, AssessmentsEstimateAssessmentData, AssessmentsEstimateAssessmentErrors, AssessmentsEstimateAssessmentResponses, AssessmentsExportAssessmentXlsxData, AssessmentsExportAssessmentXlsxErrors, AssessmentsExportAssessmentXlsxResponses, AssessmentsGetAssessmentData, AssessmentsGetAssessmentErrors, AssessmentsGetAssessmentResponses, AssessmentsGetTopicResultData, AssessmentsGetTopicResultErrors, AssessmentsGetTopicResultResponses, AssessmentsGetVersionImpactData, AssessmentsGetVersionImpactErrors, AssessmentsGetVersionImpactResponses, AssessmentsListAssessmentsData, AssessmentsListAssessmentsErrors, AssessmentsListAssessmentsResponses, AssessmentsListTopicResultsData, AssessmentsListTopicResultsErrors, AssessmentsListTopicResultsResponses, AssessmentsReopenAssessmentData, AssessmentsReopenAssessmentErrors, AssessmentsReopenAssessmentResponses, AssessmentsRerunAssessmentData, AssessmentsRerunAssessmentErrors, AssessmentsRerunAssessmentResponses, AssessmentsReviewTopicResultData, AssessmentsReviewTopicResultErrors, AssessmentsReviewTopicResultResponses, AssistantCreateAnswerData, AssistantCreateAnswerErrors, AssistantCreateAnswerResponses, AssistantDeleteThreadData, AssistantDeleteThreadErrors, AssistantDeleteThreadResponses, AssistantDeleteThreadsData, AssistantDeleteThreadsErrors, AssistantDeleteThreadsResponses, AssistantGetBudgetData, AssistantGetBudgetErrors, AssistantGetBudgetResponses, AssistantGetThreadData, AssistantGetThreadErrors, AssistantGetThreadResponses, AssistantListSuggestionsData, AssistantListSuggestionsErrors, AssistantListSuggestionsResponses, AssistantListThreadsData, AssistantListThreadsErrors, AssistantListThreadsResponses, AssistantRenameThreadData, AssistantRenameThreadErrors, AssistantRenameThreadResponses, AuthAcceptInvitationData, AuthAcceptInvitationErrors, AuthAcceptInvitationResponses, AuthChangePasswordData, AuthChangePasswordErrors, AuthChangePasswordResponses, AuthCompleteSignInData, AuthCompleteSignInErrors, AuthCompleteSignInResponses, AuthConfirmAuthenticatorReplacementData, AuthConfirmAuthenticatorReplacementErrors, AuthConfirmAuthenticatorReplacementResponses, AuthConfirmPasswordResetData, AuthConfirmPasswordResetErrors, AuthConfirmPasswordResetResponses, AuthConfirmSetupData, AuthConfirmSetupErrors, AuthConfirmSetupResponses, AuthGetAuthOptionsData, AuthGetAuthOptionsErrors, AuthGetAuthOptionsResponses, AuthGetPasswordPolicyData, AuthGetPasswordPolicyErrors, AuthGetPasswordPolicyResponses, AuthListSessionsData, AuthListSessionsErrors, AuthListSessionsResponses, AuthLookUpInvitationData, AuthLookUpInvitationErrors, AuthLookUpInvitationResponses, AuthLookUpPasswordResetData, AuthLookUpPasswordResetErrors, AuthLookUpPasswordResetResponses, AuthRequestPasswordResetData, AuthRequestPasswordResetErrors, AuthRequestPasswordResetResponses, AuthRevokeOtherSessionsData, AuthRevokeOtherSessionsErrors, AuthRevokeOtherSessionsResponses, AuthRevokeSessionData, AuthRevokeSessionErrors, AuthRevokeSessionResponses, AuthSignInData, AuthSignInErrors, AuthSignInResponses, AuthSignOutData, AuthSignOutErrors, AuthSignOutResponses, AuthStartAuthenticatorReplacementData, AuthStartAuthenticatorReplacementErrors, AuthStartAuthenticatorReplacementResponses, AuthStartSetupData, AuthStartSetupErrors, AuthStartSetupResponses, CapabilitiesCompleteCapabilityUploadData, CapabilitiesCompleteCapabilityUploadErrors, CapabilitiesCompleteCapabilityUploadResponses, CapabilitiesCreateCapabilityUploadData, CapabilitiesCreateCapabilityUploadErrors, CapabilitiesCreateCapabilityUploadResponses, CapabilitiesDeleteCapabilityDocumentData, CapabilitiesDeleteCapabilityDocumentErrors, CapabilitiesDeleteCapabilityDocumentResponses, CapabilitiesDeleteCapabilityUploadData, CapabilitiesDeleteCapabilityUploadErrors, CapabilitiesDeleteCapabilityUploadResponses, CapabilitiesExtractCapabilityDocumentData, CapabilitiesExtractCapabilityDocumentErrors, CapabilitiesExtractCapabilityDocumentResponses, CapabilitiesGetCapabilityDocumentData, CapabilitiesGetCapabilityDocumentErrors, CapabilitiesGetCapabilityDocumentPdfData, CapabilitiesGetCapabilityDocumentPdfErrors, CapabilitiesGetCapabilityDocumentPdfResponses, CapabilitiesGetCapabilityDocumentResponses, CapabilitiesGetCapabilityUploadData, CapabilitiesGetCapabilityUploadErrors, CapabilitiesGetCapabilityUploadResponses, CapabilitiesListCapabilitiesData, CapabilitiesListCapabilitiesErrors, CapabilitiesListCapabilitiesResponses, CapabilitiesListCapabilityDocumentsData, CapabilitiesListCapabilityDocumentsErrors, CapabilitiesListCapabilityDocumentsResponses, CapabilitiesPutCapabilityUploadPartData, CapabilitiesPutCapabilityUploadPartErrors, CapabilitiesPutCapabilityUploadPartResponses, CatalogGetCurrentDocumentData, CatalogGetCurrentDocumentErrors, CatalogGetCurrentDocumentResponses, CatalogGetDocumentData, CatalogGetDocumentErrors, CatalogGetDocumentResponses, CatalogGetDocumentStatsData, CatalogGetDocumentStatsErrors, CatalogGetDocumentStatsResponses, CatalogGetTableData, CatalogGetTableErrors, CatalogGetTableResponses, CatalogListAuthoritiesData, CatalogListAuthoritiesErrors, CatalogListAuthoritiesResponses, CatalogListDocumentsData, CatalogListDocumentsErrors, CatalogListDocumentsResponses, CatalogListFamiliesData, CatalogListFamiliesErrors, CatalogListFamiliesResponses, CatalogListFiguresData, CatalogListFiguresErrors, CatalogListFiguresResponses, CatalogListStandardsData, CatalogListStandardsErrors, CatalogListStandardsResponses, CatalogListTablesData, CatalogListTablesErrors, CatalogListTablesResponses, CatalogListThresholdsData, CatalogListThresholdsErrors, CatalogListThresholdsResponses, ClausesGetClauseData, ClausesGetClauseErrors, ClausesGetClauseResponses, ClausesGetTocData, ClausesGetTocErrors, ClausesGetTocResponses, ClausesListClausesData, ClausesListClausesErrors, ClausesListClausesResponses, ClausesListPageClausesData, ClausesListPageClausesErrors, ClausesListPageClausesResponses, CurvesGetChartData, CurvesGetChartErrors, CurvesGetChartResponses, CurvesGetCurveData, CurvesGetCurveErrors, CurvesGetCurveFacetsData, CurvesGetCurveFacetsErrors, CurvesGetCurveFacetsResponses, CurvesGetCurveResponses, CurvesListBandsData, CurvesListBandsErrors, CurvesListBandsResponses, CurvesListChartsData, CurvesListChartsErrors, CurvesListChartsResponses, CurvesListCurvesData, CurvesListCurvesErrors, CurvesListCurvesResponses, DatasetsGetDatasetPreviewData, DatasetsGetDatasetPreviewErrors, DatasetsGetDatasetPreviewResponses, DatasetsGetDatasetsOverviewData, DatasetsGetDatasetsOverviewErrors, DatasetsGetDatasetsOverviewResponses, DatasetsGetDocumentContentsData, DatasetsGetDocumentContentsErrors, DatasetsGetDocumentContentsResponses, DatasetsListDatasetsData, DatasetsListDatasetsErrors, DatasetsListDatasetsResponses, ExportsExportRequirementsCsvData, ExportsExportRequirementsCsvErrors, ExportsExportRequirementsCsvResponses, ExportsExportRequirementsXlsxData, ExportsExportRequirementsXlsxErrors, ExportsExportRequirementsXlsxResponses, FeedbackSendFeedbackData, FeedbackSendFeedbackErrors, FeedbackSendFeedbackResponses, JobsCancelJobData, JobsCancelJobErrors, JobsCancelJobResponses, JobsCreateJobData, JobsCreateJobErrors, JobsCreateJobResponses, JobsGetActiveJobCountData, JobsGetActiveJobCountErrors, JobsGetActiveJobCountResponses, JobsGetJobCapacityData, JobsGetJobCapacityErrors, JobsGetJobCapacityResponses, JobsGetJobData, JobsGetJobErrors, JobsGetJobEstimateData, JobsGetJobEstimateErrors, JobsGetJobEstimateResponses, JobsGetJobResponses, JobsGetRollbackImpactData, JobsGetRollbackImpactErrors, JobsGetRollbackImpactResponses, JobsListJobsData, JobsListJobsErrors, JobsListJobsResponses, JobsStreamJobEventsData, JobsStreamJobEventsErrors, JobsStreamJobEventsResponses, LifecycleGetClauseContextDiffData, LifecycleGetClauseContextDiffErrors, LifecycleGetClauseContextDiffResponses, LifecycleGetVersionDiffData, LifecycleGetVersionDiffErrors, LifecycleGetVersionDiffResponses, LifecycleListFamilyVersionsData, LifecycleListFamilyVersionsErrors, LifecycleListFamilyVersionsResponses, LifecyclePromoteDocumentData, LifecyclePromoteDocumentErrors, LifecyclePromoteDocumentResponses, LifecycleSetDocumentStatusData, LifecycleSetDocumentStatusErrors, LifecycleSetDocumentStatusResponses, MetaGetHealthData, MetaGetHealthErrors, MetaGetHealthResponses, MetaGetMeData, MetaGetMeErrors, MetaGetMeResponses, MetaGetMetaData, MetaGetMetaErrors, MetaGetMetaResponses, MetaGetReadinessData, MetaGetReadinessErrors, MetaGetReadinessResponses, MetaListJurisdictionsData, MetaListJurisdictionsErrors, MetaListJurisdictionsResponses, OperationsGetConfidenceHistogramData, OperationsGetConfidenceHistogramErrors, OperationsGetConfidenceHistogramResponses, OperationsGetDocumentAuditData, OperationsGetDocumentAuditErrors, OperationsGetDocumentAuditResponses, OperationsGetDocumentIntegrityData, OperationsGetDocumentIntegrityErrors, OperationsGetDocumentIntegrityResponses, OperationsGetRunData, OperationsGetRunErrors, OperationsGetRunReportData, OperationsGetRunReportErrors, OperationsGetRunReportResponses, OperationsGetRunResponses, OperationsGetSourceWatchData, OperationsGetSourceWatchErrors, OperationsGetSourceWatchResponses, OperationsGetSystemStatusData, OperationsGetSystemStatusErrors, OperationsGetSystemStatusResponses, OperationsListActivityData, OperationsListActivityErrors, OperationsListActivityResponses, OperationsListCompletenessGapsData, OperationsListCompletenessGapsErrors, OperationsListCompletenessGapsResponses, OperationsListEvaluationsData, OperationsListEvaluationsErrors, OperationsListEvaluationsResponses, OperationsListRunsData, OperationsListRunsErrors, OperationsListRunsResponses, OperationsListSourcesData, OperationsListSourcesErrors, OperationsListSourcesResponses, RegistryCreateRegistryAuthorityData, RegistryCreateRegistryAuthorityErrors, RegistryCreateRegistryAuthorityResponses, RegistryCreateRegistryFamilyData, RegistryCreateRegistryFamilyErrors, RegistryCreateRegistryFamilyResponses, RegistryCreateRegistryJurisdictionData, RegistryCreateRegistryJurisdictionErrors, RegistryCreateRegistryJurisdictionResponses, RegistryCreateRegistryVersionData, RegistryCreateRegistryVersionErrors, RegistryCreateRegistryVersionResponses, RegistryExportSourceRegistryData, RegistryExportSourceRegistryErrors, RegistryExportSourceRegistryResponses, RegistryGetRegistryAuthorityData, RegistryGetRegistryAuthorityErrors, RegistryGetRegistryAuthorityResponses, RegistryGetRegistryFamilyData, RegistryGetRegistryFamilyErrors, RegistryGetRegistryFamilyResponses, RegistryGetRegistryJurisdictionData, RegistryGetRegistryJurisdictionErrors, RegistryGetRegistryJurisdictionResponses, RegistryGetRegistrySummaryData, RegistryGetRegistrySummaryErrors, RegistryGetRegistrySummaryResponses, RegistryGetRegistryVersionData, RegistryGetRegistryVersionErrors, RegistryGetRegistryVersionResponses, RegistryListDatasetEventsData, RegistryListDatasetEventsErrors, RegistryListDatasetEventsResponses, RegistryListRegistryAuthoritiesData, RegistryListRegistryAuthoritiesErrors, RegistryListRegistryAuthoritiesResponses, RegistryListRegistryFamiliesData, RegistryListRegistryFamiliesErrors, RegistryListRegistryFamiliesResponses, RegistryListRegistryJurisdictionsData, RegistryListRegistryJurisdictionsErrors, RegistryListRegistryJurisdictionsResponses, RegistryListRegistryRevisionsData, RegistryListRegistryRevisionsErrors, RegistryListRegistryRevisionsResponses, RegistryListSourceAdaptersData, RegistryListSourceAdaptersErrors, RegistryListSourceAdaptersResponses, RegistryListSupportedLanguagesData, RegistryListSupportedLanguagesErrors, RegistryListSupportedLanguagesResponses, RegistryReplaceFamilySectionsData, RegistryReplaceFamilySectionsErrors, RegistryReplaceFamilySectionsResponses, RegistryRetireRegistryAuthorityData, RegistryRetireRegistryAuthorityErrors, RegistryRetireRegistryAuthorityResponses, RegistryRetireRegistryFamilyData, RegistryRetireRegistryFamilyErrors, RegistryRetireRegistryFamilyResponses, RegistryRetireRegistryJurisdictionData, RegistryRetireRegistryJurisdictionErrors, RegistryRetireRegistryJurisdictionResponses, RegistryRetireRegistryVersionData, RegistryRetireRegistryVersionErrors, RegistryRetireRegistryVersionResponses, RegistryUpdateRegistryAuthorityData, RegistryUpdateRegistryAuthorityErrors, RegistryUpdateRegistryAuthorityResponses, RegistryUpdateRegistryFamilyData, RegistryUpdateRegistryFamilyErrors, RegistryUpdateRegistryFamilyResponses, RegistryUpdateRegistryJurisdictionData, RegistryUpdateRegistryJurisdictionErrors, RegistryUpdateRegistryJurisdictionResponses, RegistryUpdateRegistryVersionData, RegistryUpdateRegistryVersionErrors, RegistryUpdateRegistryVersionResponses, RegistryVerifyDatasetEventsData, RegistryVerifyDatasetEventsErrors, RegistryVerifyDatasetEventsResponses, RequirementsGetRequirementData, RequirementsGetRequirementErrors, RequirementsGetRequirementFacetsData, RequirementsGetRequirementFacetsErrors, RequirementsGetRequirementFacetsResponses, RequirementsGetRequirementResponses, RequirementsListRequirementsData, RequirementsListRequirementsErrors, RequirementsListRequirementsResponses, SearchGetOmniboxData, SearchGetOmniboxErrors, SearchGetOmniboxResponses, SearchSearchClausesData, SearchSearchClausesErrors, SearchSearchClausesResponses, SourcesGetDocumentPdfData, SourcesGetDocumentPdfErrors, SourcesGetDocumentPdfResponses, SourcesGetFigureImageData, SourcesGetFigureImageErrors, SourcesGetFigureImageResponses, SourcesGetPageHighlightsData, SourcesGetPageHighlightsErrors, SourcesGetPageHighlightsResponses, SourcesLocateTextsData, SourcesLocateTextsErrors, SourcesLocateTextsResponses, UploadsCompleteUploadData, UploadsCompleteUploadErrors, UploadsCompleteUploadResponses, UploadsCreateUploadData, UploadsCreateUploadErrors, UploadsCreateUploadResponses, UploadsDeleteUploadData, UploadsDeleteUploadErrors, UploadsDeleteUploadResponses, UploadsGetSourceFileData, UploadsGetSourceFileErrors, UploadsGetSourceFilePdfData, UploadsGetSourceFilePdfErrors, UploadsGetSourceFilePdfResponses, UploadsGetSourceFileResponses, UploadsGetSourceProfileData, UploadsGetSourceProfileErrors, UploadsGetSourceProfileResponses, UploadsGetUploadData, UploadsGetUploadErrors, UploadsGetUploadResponses, UploadsListSourceFilesData, UploadsListSourceFilesErrors, UploadsListSourceFilesResponses, UploadsPutUploadPartData, UploadsPutUploadPartErrors, UploadsPutUploadPartResponses, VocabularyGetDefinitionData, VocabularyGetDefinitionErrors, VocabularyGetDefinitionResponses, VocabularyGetParameterData, VocabularyGetParameterErrors, VocabularyGetParameterResponses, VocabularyListDefinitionsData, VocabularyListDefinitionsErrors, VocabularyListDefinitionsResponses, VocabularyListParameterGroupsData, VocabularyListParameterGroupsErrors, VocabularyListParameterGroupsResponses, VocabularyListParameterMarketsData, VocabularyListParameterMarketsErrors, VocabularyListParameterMarketsResponses, VocabularyListParametersData, VocabularyListParametersErrors, VocabularyListParametersResponses, VocabularyLookupDefinitionData, VocabularyLookupDefinitionErrors, VocabularyLookupDefinitionResponses, WhatsNewListEntriesData, WhatsNewListEntriesErrors, WhatsNewListEntriesResponses, WhatsNewMarkSeenData, WhatsNewMarkSeenErrors, WhatsNewMarkSeenResponses } from './types.gen';
import { zAdminCreateInvitationResponse, zAdminDeleteFeedbackResponse, zAdminFeedbackSummaryResponse, zAdminGetFeedbackResponse, zAdminGetFeedbackScreenshotResponse, zAdminGetSettingsResponse, zAdminGetUserResponse, zAdminListAuthEventsResponse, zAdminListFeedbackResponse, zAdminListInvitationsResponse, zAdminListSettingsHistoryResponse, zAdminListUsersResponse, zAdminResendInvitationResponse, zAdminResetUserMfaResponse, zAdminRevokeInvitationResponse, zAdminRevokeUserSessionsResponse, zAdminSendPasswordResetResponse, zAdminSetAssistantBudgetResponse, zAdminUpdateFeedbackResponse, zAdminUpdateSettingsResponse, zAdminUpdateUserResponse, zAssessmentsApproveAssessmentResponse, zAssessmentsCreateAssessmentResponse, zAssessmentsDeleteAssessmentResponse, zAssessmentsEstimateAssessmentResponse, zAssessmentsExportAssessmentXlsxResponse, zAssessmentsGetAssessmentResponse, zAssessmentsGetTopicResultResponse, zAssessmentsGetVersionImpactResponse, zAssessmentsListAssessmentsResponse, zAssessmentsListTopicResultsResponse, zAssessmentsReopenAssessmentResponse, zAssessmentsRerunAssessmentResponse, zAssessmentsReviewTopicResultResponse, zAssistantDeleteThreadResponse, zAssistantDeleteThreadsResponse, zAssistantGetBudgetResponse, zAssistantGetThreadResponse, zAssistantListSuggestionsResponse, zAssistantListThreadsResponse, zAssistantRenameThreadResponse, zAuthAcceptInvitationResponse, zAuthChangePasswordResponse, zAuthCompleteSignInResponse, zAuthConfirmAuthenticatorReplacementResponse, zAuthConfirmPasswordResetResponse, zAuthConfirmSetupResponse, zAuthGetAuthOptionsResponse, zAuthGetPasswordPolicyResponse, zAuthListSessionsResponse, zAuthLookUpInvitationResponse, zAuthLookUpPasswordResetResponse, zAuthRevokeOtherSessionsResponse, zAuthRevokeSessionResponse, zAuthSignInResponse, zAuthSignOutResponse, zAuthStartAuthenticatorReplacementResponse, zAuthStartSetupResponse, zCapabilitiesCompleteCapabilityUploadResponse, zCapabilitiesCreateCapabilityUploadResponse, zCapabilitiesDeleteCapabilityDocumentResponse, zCapabilitiesDeleteCapabilityUploadResponse, zCapabilitiesExtractCapabilityDocumentResponse, zCapabilitiesGetCapabilityDocumentPdfResponse, zCapabilitiesGetCapabilityDocumentResponse, zCapabilitiesGetCapabilityUploadResponse, zCapabilitiesListCapabilitiesResponse, zCapabilitiesListCapabilityDocumentsResponse, zCapabilitiesPutCapabilityUploadPartResponse, zCatalogGetCurrentDocumentResponse, zCatalogGetDocumentResponse, zCatalogGetDocumentStatsResponse, zCatalogGetTableResponse, zCatalogListAuthoritiesResponse, zCatalogListDocumentsResponse, zCatalogListFamiliesResponse, zCatalogListFiguresResponse, zCatalogListStandardsResponse, zCatalogListTablesResponse, zCatalogListThresholdsResponse, zClausesGetClauseResponse, zClausesGetTocResponse, zClausesListClausesResponse, zClausesListPageClausesResponse, zCurvesGetChartResponse, zCurvesGetCurveFacetsResponse, zCurvesGetCurveResponse, zCurvesListBandsResponse, zCurvesListChartsResponse, zCurvesListCurvesResponse, zDatasetsGetDatasetPreviewResponse, zDatasetsGetDatasetsOverviewResponse, zDatasetsGetDocumentContentsResponse, zDatasetsListDatasetsResponse, zExportsExportRequirementsCsvResponse, zExportsExportRequirementsXlsxResponse, zFeedbackSendFeedbackResponse, zJobsCancelJobResponse, zJobsCreateJobResponse, zJobsGetActiveJobCountResponse, zJobsGetJobCapacityResponse, zJobsGetJobEstimateResponse, zJobsGetJobResponse, zJobsGetRollbackImpactResponse, zJobsListJobsResponse, zLifecycleGetClauseContextDiffResponse, zLifecycleGetVersionDiffResponse, zLifecycleListFamilyVersionsResponse, zLifecyclePromoteDocumentResponse, zLifecycleSetDocumentStatusResponse, zMetaGetHealthResponse, zMetaGetMeResponse, zMetaGetMetaResponse, zMetaGetReadinessResponse, zMetaListJurisdictionsResponse, zOperationsGetConfidenceHistogramResponse, zOperationsGetDocumentAuditResponse, zOperationsGetDocumentIntegrityResponse, zOperationsGetRunReportResponse, zOperationsGetRunResponse, zOperationsGetSourceWatchResponse, zOperationsGetSystemStatusResponse, zOperationsListActivityResponse, zOperationsListCompletenessGapsResponse, zOperationsListEvaluationsResponse, zOperationsListRunsResponse, zOperationsListSourcesResponse, zRegistryCreateRegistryAuthorityResponse, zRegistryCreateRegistryFamilyResponse, zRegistryCreateRegistryJurisdictionResponse, zRegistryCreateRegistryVersionResponse, zRegistryExportSourceRegistryResponse, zRegistryGetRegistryAuthorityResponse, zRegistryGetRegistryFamilyResponse, zRegistryGetRegistryJurisdictionResponse, zRegistryGetRegistrySummaryResponse, zRegistryGetRegistryVersionResponse, zRegistryListDatasetEventsResponse, zRegistryListRegistryAuthoritiesResponse, zRegistryListRegistryFamiliesResponse, zRegistryListRegistryJurisdictionsResponse, zRegistryListRegistryRevisionsResponse, zRegistryListSourceAdaptersResponse, zRegistryListSupportedLanguagesResponse, zRegistryReplaceFamilySectionsResponse, zRegistryRetireRegistryAuthorityResponse, zRegistryRetireRegistryFamilyResponse, zRegistryRetireRegistryJurisdictionResponse, zRegistryRetireRegistryVersionResponse, zRegistryUpdateRegistryAuthorityResponse, zRegistryUpdateRegistryFamilyResponse, zRegistryUpdateRegistryJurisdictionResponse, zRegistryUpdateRegistryVersionResponse, zRegistryVerifyDatasetEventsResponse, zRequirementsGetRequirementFacetsResponse, zRequirementsGetRequirementResponse, zRequirementsListRequirementsResponse, zSearchGetOmniboxResponse, zSearchSearchClausesResponse, zSourcesGetDocumentPdfResponse, zSourcesGetFigureImageResponse, zSourcesGetPageHighlightsResponse, zSourcesLocateTextsResponse, zUploadsCompleteUploadResponse, zUploadsCreateUploadResponse, zUploadsDeleteUploadResponse, zUploadsGetSourceFilePdfResponse, zUploadsGetSourceFileResponse, zUploadsGetSourceProfileResponse, zUploadsGetUploadResponse, zUploadsListSourceFilesResponse, zUploadsPutUploadPartResponse, zVocabularyGetDefinitionResponse, zVocabularyGetParameterResponse, zVocabularyListDefinitionsResponse, zVocabularyListParameterGroupsResponse, zVocabularyListParameterMarketsResponse, zVocabularyListParametersResponse, zVocabularyLookupDefinitionResponse, zWhatsNewListEntriesResponse, zWhatsNewMarkSeenResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List Activity
 */
export const operationsListActivity = <ThrowOnError extends boolean = false>(options?: Options<OperationsListActivityData, ThrowOnError>): RequestResult<OperationsListActivityResponses, OperationsListActivityErrors, ThrowOnError> => (options?.client ?? client).get<OperationsListActivityResponses, OperationsListActivityErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsListActivityResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/activity',
    ...options
});

/**
 * List Auth Events
 */
export const adminListAuthEvents = <ThrowOnError extends boolean = false>(options?: Options<AdminListAuthEventsData, ThrowOnError>): RequestResult<AdminListAuthEventsResponses, AdminListAuthEventsErrors, ThrowOnError> => (options?.client ?? client).get<AdminListAuthEventsResponses, AdminListAuthEventsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminListAuthEventsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/auth-events',
    ...options
});

/**
 * List Datasets
 */
export const datasetsListDatasets = <ThrowOnError extends boolean = false>(options?: Options<DatasetsListDatasetsData, ThrowOnError>): RequestResult<DatasetsListDatasetsResponses, DatasetsListDatasetsErrors, ThrowOnError> => (options?.client ?? client).get<DatasetsListDatasetsResponses, DatasetsListDatasetsErrors, ThrowOnError>({
    responseValidator: async (data) => await zDatasetsListDatasetsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/datasets',
    ...options
});

/**
 * Get Datasets Overview
 */
export const datasetsGetDatasetsOverview = <ThrowOnError extends boolean = false>(options?: Options<DatasetsGetDatasetsOverviewData, ThrowOnError>): RequestResult<DatasetsGetDatasetsOverviewResponses, DatasetsGetDatasetsOverviewErrors, ThrowOnError> => (options?.client ?? client).get<DatasetsGetDatasetsOverviewResponses, DatasetsGetDatasetsOverviewErrors, ThrowOnError>({
    responseValidator: async (data) => await zDatasetsGetDatasetsOverviewResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/datasets/overview',
    ...options
});

/**
 * Get Document Contents
 */
export const datasetsGetDocumentContents = <ThrowOnError extends boolean = false>(options: Options<DatasetsGetDocumentContentsData, ThrowOnError>): RequestResult<DatasetsGetDocumentContentsResponses, DatasetsGetDocumentContentsErrors, ThrowOnError> => (options.client ?? client).get<DatasetsGetDocumentContentsResponses, DatasetsGetDocumentContentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zDatasetsGetDocumentContentsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/datasets/{doc_uid}/contents',
    ...options
});

/**
 * Get Dataset Preview
 */
export const datasetsGetDatasetPreview = <ThrowOnError extends boolean = false>(options: Options<DatasetsGetDatasetPreviewData, ThrowOnError>): RequestResult<DatasetsGetDatasetPreviewResponses, DatasetsGetDatasetPreviewErrors, ThrowOnError> => (options.client ?? client).get<DatasetsGetDatasetPreviewResponses, DatasetsGetDatasetPreviewErrors, ThrowOnError>({
    responseValidator: async (data) => await zDatasetsGetDatasetPreviewResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/datasets/{doc_uid}/preview',
    ...options
});

/**
 * List Feedback
 */
export const adminListFeedback = <ThrowOnError extends boolean = false>(options?: Options<AdminListFeedbackData, ThrowOnError>): RequestResult<AdminListFeedbackResponses, AdminListFeedbackErrors, ThrowOnError> => (options?.client ?? client).get<AdminListFeedbackResponses, AdminListFeedbackErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminListFeedbackResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/feedback',
    ...options
});

/**
 * Feedback Summary
 */
export const adminFeedbackSummary = <ThrowOnError extends boolean = false>(options?: Options<AdminFeedbackSummaryData, ThrowOnError>): RequestResult<AdminFeedbackSummaryResponses, AdminFeedbackSummaryErrors, ThrowOnError> => (options?.client ?? client).get<AdminFeedbackSummaryResponses, AdminFeedbackSummaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminFeedbackSummaryResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/feedback/summary',
    ...options
});

/**
 * Delete Feedback
 */
export const adminDeleteFeedback = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteFeedbackData, ThrowOnError>): RequestResult<AdminDeleteFeedbackResponses, AdminDeleteFeedbackErrors, ThrowOnError> => (options.client ?? client).delete<AdminDeleteFeedbackResponses, AdminDeleteFeedbackErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminDeleteFeedbackResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/feedback/{report_id}',
    ...options
});

/**
 * Get Feedback
 */
export const adminGetFeedback = <ThrowOnError extends boolean = false>(options: Options<AdminGetFeedbackData, ThrowOnError>): RequestResult<AdminGetFeedbackResponses, AdminGetFeedbackErrors, ThrowOnError> => (options.client ?? client).get<AdminGetFeedbackResponses, AdminGetFeedbackErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminGetFeedbackResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/feedback/{report_id}',
    ...options
});

/**
 * Update Feedback
 */
export const adminUpdateFeedback = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateFeedbackData, ThrowOnError>): RequestResult<AdminUpdateFeedbackResponses, AdminUpdateFeedbackErrors, ThrowOnError> => (options.client ?? client).patch<AdminUpdateFeedbackResponses, AdminUpdateFeedbackErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminUpdateFeedbackResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/feedback/{report_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Feedback Screenshot
 */
export const adminGetFeedbackScreenshot = <ThrowOnError extends boolean = false>(options: Options<AdminGetFeedbackScreenshotData, ThrowOnError>): RequestResult<AdminGetFeedbackScreenshotResponses, AdminGetFeedbackScreenshotErrors, ThrowOnError> => (options.client ?? client).get<AdminGetFeedbackScreenshotResponses, AdminGetFeedbackScreenshotErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminGetFeedbackScreenshotResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/feedback/{report_id}/screenshot',
    ...options
});

/**
 * List Invitations
 */
export const adminListInvitations = <ThrowOnError extends boolean = false>(options?: Options<AdminListInvitationsData, ThrowOnError>): RequestResult<AdminListInvitationsResponses, AdminListInvitationsErrors, ThrowOnError> => (options?.client ?? client).get<AdminListInvitationsResponses, AdminListInvitationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminListInvitationsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/invitations',
    ...options
});

/**
 * Create Invitation
 */
export const adminCreateInvitation = <ThrowOnError extends boolean = false>(options: Options<AdminCreateInvitationData, ThrowOnError>): RequestResult<AdminCreateInvitationResponses, AdminCreateInvitationErrors, ThrowOnError> => (options.client ?? client).post<AdminCreateInvitationResponses, AdminCreateInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminCreateInvitationResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Invitation
 */
export const adminRevokeInvitation = <ThrowOnError extends boolean = false>(options: Options<AdminRevokeInvitationData, ThrowOnError>): RequestResult<AdminRevokeInvitationResponses, AdminRevokeInvitationErrors, ThrowOnError> => (options.client ?? client).delete<AdminRevokeInvitationResponses, AdminRevokeInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminRevokeInvitationResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/invitations/{invitation_id}',
    ...options
});

/**
 * Resend Invitation
 */
export const adminResendInvitation = <ThrowOnError extends boolean = false>(options: Options<AdminResendInvitationData, ThrowOnError>): RequestResult<AdminResendInvitationResponses, AdminResendInvitationErrors, ThrowOnError> => (options.client ?? client).post<AdminResendInvitationResponses, AdminResendInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminResendInvitationResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/invitations/{invitation_id}/resend',
    ...options
});

/**
 * Get Registry Summary
 */
export const registryGetRegistrySummary = <ThrowOnError extends boolean = false>(options?: Options<RegistryGetRegistrySummaryData, ThrowOnError>): RequestResult<RegistryGetRegistrySummaryResponses, RegistryGetRegistrySummaryErrors, ThrowOnError> => (options?.client ?? client).get<RegistryGetRegistrySummaryResponses, RegistryGetRegistrySummaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryGetRegistrySummaryResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry',
    ...options
});

/**
 * List Source Adapters
 */
export const registryListSourceAdapters = <ThrowOnError extends boolean = false>(options?: Options<RegistryListSourceAdaptersData, ThrowOnError>): RequestResult<RegistryListSourceAdaptersResponses, RegistryListSourceAdaptersErrors, ThrowOnError> => (options?.client ?? client).get<RegistryListSourceAdaptersResponses, RegistryListSourceAdaptersErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryListSourceAdaptersResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/adapters',
    ...options
});

/**
 * List Registry Authorities
 */
export const registryListRegistryAuthorities = <ThrowOnError extends boolean = false>(options?: Options<RegistryListRegistryAuthoritiesData, ThrowOnError>): RequestResult<RegistryListRegistryAuthoritiesResponses, RegistryListRegistryAuthoritiesErrors, ThrowOnError> => (options?.client ?? client).get<RegistryListRegistryAuthoritiesResponses, RegistryListRegistryAuthoritiesErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryListRegistryAuthoritiesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/authorities',
    ...options
});

/**
 * Create Registry Authority
 */
export const registryCreateRegistryAuthority = <ThrowOnError extends boolean = false>(options: Options<RegistryCreateRegistryAuthorityData, ThrowOnError>): RequestResult<RegistryCreateRegistryAuthorityResponses, RegistryCreateRegistryAuthorityErrors, ThrowOnError> => (options.client ?? client).post<RegistryCreateRegistryAuthorityResponses, RegistryCreateRegistryAuthorityErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryCreateRegistryAuthorityResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/authorities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retire Registry Authority
 */
export const registryRetireRegistryAuthority = <ThrowOnError extends boolean = false>(options: Options<RegistryRetireRegistryAuthorityData, ThrowOnError>): RequestResult<RegistryRetireRegistryAuthorityResponses, RegistryRetireRegistryAuthorityErrors, ThrowOnError> => (options.client ?? client).delete<RegistryRetireRegistryAuthorityResponses, RegistryRetireRegistryAuthorityErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryRetireRegistryAuthorityResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/authorities/{authority_id}',
    ...options
});

/**
 * Get Registry Authority
 */
export const registryGetRegistryAuthority = <ThrowOnError extends boolean = false>(options: Options<RegistryGetRegistryAuthorityData, ThrowOnError>): RequestResult<RegistryGetRegistryAuthorityResponses, RegistryGetRegistryAuthorityErrors, ThrowOnError> => (options.client ?? client).get<RegistryGetRegistryAuthorityResponses, RegistryGetRegistryAuthorityErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryGetRegistryAuthorityResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/authorities/{authority_id}',
    ...options
});

/**
 * Update Registry Authority
 */
export const registryUpdateRegistryAuthority = <ThrowOnError extends boolean = false>(options: Options<RegistryUpdateRegistryAuthorityData, ThrowOnError>): RequestResult<RegistryUpdateRegistryAuthorityResponses, RegistryUpdateRegistryAuthorityErrors, ThrowOnError> => (options.client ?? client).patch<RegistryUpdateRegistryAuthorityResponses, RegistryUpdateRegistryAuthorityErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryUpdateRegistryAuthorityResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/authorities/{authority_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Registry Revisions
 */
export const registryListRegistryRevisions = <ThrowOnError extends boolean = false>(options: Options<RegistryListRegistryRevisionsData, ThrowOnError>): RequestResult<RegistryListRegistryRevisionsResponses, RegistryListRegistryRevisionsErrors, ThrowOnError> => (options.client ?? client).get<RegistryListRegistryRevisionsResponses, RegistryListRegistryRevisionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryListRegistryRevisionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/entries/{entry_key}/revisions',
    ...options
});

/**
 * List Dataset Events
 */
export const registryListDatasetEvents = <ThrowOnError extends boolean = false>(options?: Options<RegistryListDatasetEventsData, ThrowOnError>): RequestResult<RegistryListDatasetEventsResponses, RegistryListDatasetEventsErrors, ThrowOnError> => (options?.client ?? client).get<RegistryListDatasetEventsResponses, RegistryListDatasetEventsErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryListDatasetEventsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/events',
    ...options
});

/**
 * Verify Dataset Events
 */
export const registryVerifyDatasetEvents = <ThrowOnError extends boolean = false>(options?: Options<RegistryVerifyDatasetEventsData, ThrowOnError>): RequestResult<RegistryVerifyDatasetEventsResponses, RegistryVerifyDatasetEventsErrors, ThrowOnError> => (options?.client ?? client).get<RegistryVerifyDatasetEventsResponses, RegistryVerifyDatasetEventsErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryVerifyDatasetEventsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/events/verify',
    ...options
});

/**
 * Export Source Registry
 */
export const registryExportSourceRegistry = <ThrowOnError extends boolean = false>(options?: Options<RegistryExportSourceRegistryData, ThrowOnError>): RequestResult<RegistryExportSourceRegistryResponses, RegistryExportSourceRegistryErrors, ThrowOnError> => (options?.client ?? client).get<RegistryExportSourceRegistryResponses, RegistryExportSourceRegistryErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryExportSourceRegistryResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/export',
    ...options
});

/**
 * List Registry Families
 */
export const registryListRegistryFamilies = <ThrowOnError extends boolean = false>(options?: Options<RegistryListRegistryFamiliesData, ThrowOnError>): RequestResult<RegistryListRegistryFamiliesResponses, RegistryListRegistryFamiliesErrors, ThrowOnError> => (options?.client ?? client).get<RegistryListRegistryFamiliesResponses, RegistryListRegistryFamiliesErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryListRegistryFamiliesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families',
    ...options
});

/**
 * Create Registry Family
 */
export const registryCreateRegistryFamily = <ThrowOnError extends boolean = false>(options: Options<RegistryCreateRegistryFamilyData, ThrowOnError>): RequestResult<RegistryCreateRegistryFamilyResponses, RegistryCreateRegistryFamilyErrors, ThrowOnError> => (options.client ?? client).post<RegistryCreateRegistryFamilyResponses, RegistryCreateRegistryFamilyErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryCreateRegistryFamilyResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retire Registry Family
 */
export const registryRetireRegistryFamily = <ThrowOnError extends boolean = false>(options: Options<RegistryRetireRegistryFamilyData, ThrowOnError>): RequestResult<RegistryRetireRegistryFamilyResponses, RegistryRetireRegistryFamilyErrors, ThrowOnError> => (options.client ?? client).delete<RegistryRetireRegistryFamilyResponses, RegistryRetireRegistryFamilyErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryRetireRegistryFamilyResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families/{family_id}',
    ...options
});

/**
 * Get Registry Family
 */
export const registryGetRegistryFamily = <ThrowOnError extends boolean = false>(options: Options<RegistryGetRegistryFamilyData, ThrowOnError>): RequestResult<RegistryGetRegistryFamilyResponses, RegistryGetRegistryFamilyErrors, ThrowOnError> => (options.client ?? client).get<RegistryGetRegistryFamilyResponses, RegistryGetRegistryFamilyErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryGetRegistryFamilyResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families/{family_id}',
    ...options
});

/**
 * Update Registry Family
 */
export const registryUpdateRegistryFamily = <ThrowOnError extends boolean = false>(options: Options<RegistryUpdateRegistryFamilyData, ThrowOnError>): RequestResult<RegistryUpdateRegistryFamilyResponses, RegistryUpdateRegistryFamilyErrors, ThrowOnError> => (options.client ?? client).patch<RegistryUpdateRegistryFamilyResponses, RegistryUpdateRegistryFamilyErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryUpdateRegistryFamilyResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families/{family_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace Family Sections
 */
export const registryReplaceFamilySections = <ThrowOnError extends boolean = false>(options: Options<RegistryReplaceFamilySectionsData, ThrowOnError>): RequestResult<RegistryReplaceFamilySectionsResponses, RegistryReplaceFamilySectionsErrors, ThrowOnError> => (options.client ?? client).put<RegistryReplaceFamilySectionsResponses, RegistryReplaceFamilySectionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryReplaceFamilySectionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families/{family_id}/sections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Registry Version
 */
export const registryCreateRegistryVersion = <ThrowOnError extends boolean = false>(options: Options<RegistryCreateRegistryVersionData, ThrowOnError>): RequestResult<RegistryCreateRegistryVersionResponses, RegistryCreateRegistryVersionErrors, ThrowOnError> => (options.client ?? client).post<RegistryCreateRegistryVersionResponses, RegistryCreateRegistryVersionErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryCreateRegistryVersionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families/{family_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retire Registry Version
 */
export const registryRetireRegistryVersion = <ThrowOnError extends boolean = false>(options: Options<RegistryRetireRegistryVersionData, ThrowOnError>): RequestResult<RegistryRetireRegistryVersionResponses, RegistryRetireRegistryVersionErrors, ThrowOnError> => (options.client ?? client).delete<RegistryRetireRegistryVersionResponses, RegistryRetireRegistryVersionErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryRetireRegistryVersionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families/{family_id}/versions/{version_label}',
    ...options
});

/**
 * Get Registry Version
 */
export const registryGetRegistryVersion = <ThrowOnError extends boolean = false>(options: Options<RegistryGetRegistryVersionData, ThrowOnError>): RequestResult<RegistryGetRegistryVersionResponses, RegistryGetRegistryVersionErrors, ThrowOnError> => (options.client ?? client).get<RegistryGetRegistryVersionResponses, RegistryGetRegistryVersionErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryGetRegistryVersionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families/{family_id}/versions/{version_label}',
    ...options
});

/**
 * Update Registry Version
 */
export const registryUpdateRegistryVersion = <ThrowOnError extends boolean = false>(options: Options<RegistryUpdateRegistryVersionData, ThrowOnError>): RequestResult<RegistryUpdateRegistryVersionResponses, RegistryUpdateRegistryVersionErrors, ThrowOnError> => (options.client ?? client).patch<RegistryUpdateRegistryVersionResponses, RegistryUpdateRegistryVersionErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryUpdateRegistryVersionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/families/{family_id}/versions/{version_label}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Registry Jurisdictions
 */
export const registryListRegistryJurisdictions = <ThrowOnError extends boolean = false>(options?: Options<RegistryListRegistryJurisdictionsData, ThrowOnError>): RequestResult<RegistryListRegistryJurisdictionsResponses, RegistryListRegistryJurisdictionsErrors, ThrowOnError> => (options?.client ?? client).get<RegistryListRegistryJurisdictionsResponses, RegistryListRegistryJurisdictionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryListRegistryJurisdictionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/jurisdictions',
    ...options
});

/**
 * Create Registry Jurisdiction
 */
export const registryCreateRegistryJurisdiction = <ThrowOnError extends boolean = false>(options: Options<RegistryCreateRegistryJurisdictionData, ThrowOnError>): RequestResult<RegistryCreateRegistryJurisdictionResponses, RegistryCreateRegistryJurisdictionErrors, ThrowOnError> => (options.client ?? client).post<RegistryCreateRegistryJurisdictionResponses, RegistryCreateRegistryJurisdictionErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryCreateRegistryJurisdictionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/jurisdictions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retire Registry Jurisdiction
 */
export const registryRetireRegistryJurisdiction = <ThrowOnError extends boolean = false>(options: Options<RegistryRetireRegistryJurisdictionData, ThrowOnError>): RequestResult<RegistryRetireRegistryJurisdictionResponses, RegistryRetireRegistryJurisdictionErrors, ThrowOnError> => (options.client ?? client).delete<RegistryRetireRegistryJurisdictionResponses, RegistryRetireRegistryJurisdictionErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryRetireRegistryJurisdictionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/jurisdictions/{jurisdiction_id}',
    ...options
});

/**
 * Get Registry Jurisdiction
 */
export const registryGetRegistryJurisdiction = <ThrowOnError extends boolean = false>(options: Options<RegistryGetRegistryJurisdictionData, ThrowOnError>): RequestResult<RegistryGetRegistryJurisdictionResponses, RegistryGetRegistryJurisdictionErrors, ThrowOnError> => (options.client ?? client).get<RegistryGetRegistryJurisdictionResponses, RegistryGetRegistryJurisdictionErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryGetRegistryJurisdictionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/jurisdictions/{jurisdiction_id}',
    ...options
});

/**
 * Update Registry Jurisdiction
 */
export const registryUpdateRegistryJurisdiction = <ThrowOnError extends boolean = false>(options: Options<RegistryUpdateRegistryJurisdictionData, ThrowOnError>): RequestResult<RegistryUpdateRegistryJurisdictionResponses, RegistryUpdateRegistryJurisdictionErrors, ThrowOnError> => (options.client ?? client).patch<RegistryUpdateRegistryJurisdictionResponses, RegistryUpdateRegistryJurisdictionErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryUpdateRegistryJurisdictionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/jurisdictions/{jurisdiction_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Supported Languages
 */
export const registryListSupportedLanguages = <ThrowOnError extends boolean = false>(options?: Options<RegistryListSupportedLanguagesData, ThrowOnError>): RequestResult<RegistryListSupportedLanguagesResponses, RegistryListSupportedLanguagesErrors, ThrowOnError> => (options?.client ?? client).get<RegistryListSupportedLanguagesResponses, RegistryListSupportedLanguagesErrors, ThrowOnError>({
    responseValidator: async (data) => await zRegistryListSupportedLanguagesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/registry/languages',
    ...options
});

/**
 * Get Settings
 */
export const adminGetSettings = <ThrowOnError extends boolean = false>(options?: Options<AdminGetSettingsData, ThrowOnError>): RequestResult<AdminGetSettingsResponses, AdminGetSettingsErrors, ThrowOnError> => (options?.client ?? client).get<AdminGetSettingsResponses, AdminGetSettingsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminGetSettingsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/settings',
    ...options
});

/**
 * Update Settings
 */
export const adminUpdateSettings = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateSettingsData, ThrowOnError>): RequestResult<AdminUpdateSettingsResponses, AdminUpdateSettingsErrors, ThrowOnError> => (options.client ?? client).patch<AdminUpdateSettingsResponses, AdminUpdateSettingsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminUpdateSettingsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Settings History
 */
export const adminListSettingsHistory = <ThrowOnError extends boolean = false>(options?: Options<AdminListSettingsHistoryData, ThrowOnError>): RequestResult<AdminListSettingsHistoryResponses, AdminListSettingsHistoryErrors, ThrowOnError> => (options?.client ?? client).get<AdminListSettingsHistoryResponses, AdminListSettingsHistoryErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminListSettingsHistoryResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/settings/history',
    ...options
});

/**
 * List Source Files
 */
export const uploadsListSourceFiles = <ThrowOnError extends boolean = false>(options?: Options<UploadsListSourceFilesData, ThrowOnError>): RequestResult<UploadsListSourceFilesResponses, UploadsListSourceFilesErrors, ThrowOnError> => (options?.client ?? client).get<UploadsListSourceFilesResponses, UploadsListSourceFilesErrors, ThrowOnError>({
    responseValidator: async (data) => await zUploadsListSourceFilesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/source-files',
    ...options
});

/**
 * Get Source File
 */
export const uploadsGetSourceFile = <ThrowOnError extends boolean = false>(options: Options<UploadsGetSourceFileData, ThrowOnError>): RequestResult<UploadsGetSourceFileResponses, UploadsGetSourceFileErrors, ThrowOnError> => (options.client ?? client).get<UploadsGetSourceFileResponses, UploadsGetSourceFileErrors, ThrowOnError>({
    responseValidator: async (data) => await zUploadsGetSourceFileResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/source-files/{sha256}',
    ...options
});

/**
 * Get Source File Pdf
 */
export const uploadsGetSourceFilePdf = <ThrowOnError extends boolean = false>(options: Options<UploadsGetSourceFilePdfData, ThrowOnError>): RequestResult<UploadsGetSourceFilePdfResponses, UploadsGetSourceFilePdfErrors, ThrowOnError> => (options.client ?? client).get<UploadsGetSourceFilePdfResponses, UploadsGetSourceFilePdfErrors, ThrowOnError>({
    responseValidator: async (data) => await zUploadsGetSourceFilePdfResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/source-files/{sha256}/pdf',
    ...options
});

/**
 * Get Source Profile
 */
export const uploadsGetSourceProfile = <ThrowOnError extends boolean = false>(options: Options<UploadsGetSourceProfileData, ThrowOnError>): RequestResult<UploadsGetSourceProfileResponses, UploadsGetSourceProfileErrors, ThrowOnError> => (options.client ?? client).get<UploadsGetSourceProfileResponses, UploadsGetSourceProfileErrors, ThrowOnError>({
    responseValidator: async (data) => await zUploadsGetSourceProfileResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/source-files/{sha256}/profile',
    ...options
});

/**
 * Create Upload
 */
export const uploadsCreateUpload = <ThrowOnError extends boolean = false>(options: Options<UploadsCreateUploadData, ThrowOnError>): RequestResult<UploadsCreateUploadResponses, UploadsCreateUploadErrors, ThrowOnError> => (options.client ?? client).post<UploadsCreateUploadResponses, UploadsCreateUploadErrors, ThrowOnError>({
    responseValidator: async (data) => await zUploadsCreateUploadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/uploads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Upload
 */
export const uploadsDeleteUpload = <ThrowOnError extends boolean = false>(options: Options<UploadsDeleteUploadData, ThrowOnError>): RequestResult<UploadsDeleteUploadResponses, UploadsDeleteUploadErrors, ThrowOnError> => (options.client ?? client).delete<UploadsDeleteUploadResponses, UploadsDeleteUploadErrors, ThrowOnError>({
    responseValidator: async (data) => await zUploadsDeleteUploadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/uploads/{upload_id}',
    ...options
});

/**
 * Get Upload
 */
export const uploadsGetUpload = <ThrowOnError extends boolean = false>(options: Options<UploadsGetUploadData, ThrowOnError>): RequestResult<UploadsGetUploadResponses, UploadsGetUploadErrors, ThrowOnError> => (options.client ?? client).get<UploadsGetUploadResponses, UploadsGetUploadErrors, ThrowOnError>({
    responseValidator: async (data) => await zUploadsGetUploadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/uploads/{upload_id}',
    ...options
});

/**
 * Complete Upload
 */
export const uploadsCompleteUpload = <ThrowOnError extends boolean = false>(options: Options<UploadsCompleteUploadData, ThrowOnError>): RequestResult<UploadsCompleteUploadResponses, UploadsCompleteUploadErrors, ThrowOnError> => (options.client ?? client).post<UploadsCompleteUploadResponses, UploadsCompleteUploadErrors, ThrowOnError>({
    responseValidator: async (data) => await zUploadsCompleteUploadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/uploads/{upload_id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Upload Part
 */
export const uploadsPutUploadPart = <ThrowOnError extends boolean = false>(options: Options<UploadsPutUploadPartData, ThrowOnError>): RequestResult<UploadsPutUploadPartResponses, UploadsPutUploadPartErrors, ThrowOnError> => (options.client ?? client).put<UploadsPutUploadPartResponses, UploadsPutUploadPartErrors, ThrowOnError>({
    bodySerializer: null,
    responseValidator: async (data) => await zUploadsPutUploadPartResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/uploads/{upload_id}/parts/{part_number}',
    ...options,
    headers: {
        'Content-Type': 'application/octet-stream',
        ...options.headers
    }
});

/**
 * List Users
 */
export const adminListUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminListUsersData, ThrowOnError>): RequestResult<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError> => (options?.client ?? client).get<AdminListUsersResponses, AdminListUsersErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminListUsersResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users',
    ...options
});

/**
 * Get User
 */
export const adminGetUser = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserData, ThrowOnError>): RequestResult<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError> => (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminGetUserResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}',
    ...options
});

/**
 * Update User
 */
export const adminUpdateUser = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateUserData, ThrowOnError>): RequestResult<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError> => (options.client ?? client).patch<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminUpdateUserResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Assistant Budget
 */
export const adminSetAssistantBudget = <ThrowOnError extends boolean = false>(options: Options<AdminSetAssistantBudgetData, ThrowOnError>): RequestResult<AdminSetAssistantBudgetResponses, AdminSetAssistantBudgetErrors, ThrowOnError> => (options.client ?? client).put<AdminSetAssistantBudgetResponses, AdminSetAssistantBudgetErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminSetAssistantBudgetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}/assistant-budget',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset User Mfa
 */
export const adminResetUserMfa = <ThrowOnError extends boolean = false>(options: Options<AdminResetUserMfaData, ThrowOnError>): RequestResult<AdminResetUserMfaResponses, AdminResetUserMfaErrors, ThrowOnError> => (options.client ?? client).post<AdminResetUserMfaResponses, AdminResetUserMfaErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminResetUserMfaResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}/mfa-reset',
    ...options
});

/**
 * Send Password Reset
 */
export const adminSendPasswordReset = <ThrowOnError extends boolean = false>(options: Options<AdminSendPasswordResetData, ThrowOnError>): RequestResult<AdminSendPasswordResetResponses, AdminSendPasswordResetErrors, ThrowOnError> => (options.client ?? client).post<AdminSendPasswordResetResponses, AdminSendPasswordResetErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminSendPasswordResetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}/password-reset',
    ...options
});

/**
 * Revoke User Sessions
 */
export const adminRevokeUserSessions = <ThrowOnError extends boolean = false>(options: Options<AdminRevokeUserSessionsData, ThrowOnError>): RequestResult<AdminRevokeUserSessionsResponses, AdminRevokeUserSessionsErrors, ThrowOnError> => (options.client ?? client).delete<AdminRevokeUserSessionsResponses, AdminRevokeUserSessionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminRevokeUserSessionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/admin/users/{user_id}/sessions',
    ...options
});

/**
 * List Assessments
 */
export const assessmentsListAssessments = <ThrowOnError extends boolean = false>(options?: Options<AssessmentsListAssessmentsData, ThrowOnError>): RequestResult<AssessmentsListAssessmentsResponses, AssessmentsListAssessmentsErrors, ThrowOnError> => (options?.client ?? client).get<AssessmentsListAssessmentsResponses, AssessmentsListAssessmentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsListAssessmentsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments',
    ...options
});

/**
 * Create Assessment
 */
export const assessmentsCreateAssessment = <ThrowOnError extends boolean = false>(options: Options<AssessmentsCreateAssessmentData, ThrowOnError>): RequestResult<AssessmentsCreateAssessmentResponses, AssessmentsCreateAssessmentErrors, ThrowOnError> => (options.client ?? client).post<AssessmentsCreateAssessmentResponses, AssessmentsCreateAssessmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsCreateAssessmentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Estimate Assessment
 */
export const assessmentsEstimateAssessment = <ThrowOnError extends boolean = false>(options: Options<AssessmentsEstimateAssessmentData, ThrowOnError>): RequestResult<AssessmentsEstimateAssessmentResponses, AssessmentsEstimateAssessmentErrors, ThrowOnError> => (options.client ?? client).get<AssessmentsEstimateAssessmentResponses, AssessmentsEstimateAssessmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsEstimateAssessmentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/estimate',
    ...options
});

/**
 * Delete Assessment
 */
export const assessmentsDeleteAssessment = <ThrowOnError extends boolean = false>(options: Options<AssessmentsDeleteAssessmentData, ThrowOnError>): RequestResult<AssessmentsDeleteAssessmentResponses, AssessmentsDeleteAssessmentErrors, ThrowOnError> => (options.client ?? client).delete<AssessmentsDeleteAssessmentResponses, AssessmentsDeleteAssessmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsDeleteAssessmentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}',
    ...options
});

/**
 * Get Assessment
 */
export const assessmentsGetAssessment = <ThrowOnError extends boolean = false>(options: Options<AssessmentsGetAssessmentData, ThrowOnError>): RequestResult<AssessmentsGetAssessmentResponses, AssessmentsGetAssessmentErrors, ThrowOnError> => (options.client ?? client).get<AssessmentsGetAssessmentResponses, AssessmentsGetAssessmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsGetAssessmentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}',
    ...options
});

/**
 * Approve Assessment
 */
export const assessmentsApproveAssessment = <ThrowOnError extends boolean = false>(options: Options<AssessmentsApproveAssessmentData, ThrowOnError>): RequestResult<AssessmentsApproveAssessmentResponses, AssessmentsApproveAssessmentErrors, ThrowOnError> => (options.client ?? client).post<AssessmentsApproveAssessmentResponses, AssessmentsApproveAssessmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsApproveAssessmentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Assessment Xlsx
 */
export const assessmentsExportAssessmentXlsx = <ThrowOnError extends boolean = false>(options: Options<AssessmentsExportAssessmentXlsxData, ThrowOnError>): RequestResult<AssessmentsExportAssessmentXlsxResponses, AssessmentsExportAssessmentXlsxErrors, ThrowOnError> => (options.client ?? client).get<AssessmentsExportAssessmentXlsxResponses, AssessmentsExportAssessmentXlsxErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsExportAssessmentXlsxResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}/export.xlsx',
    ...options
});

/**
 * Reopen Assessment
 */
export const assessmentsReopenAssessment = <ThrowOnError extends boolean = false>(options: Options<AssessmentsReopenAssessmentData, ThrowOnError>): RequestResult<AssessmentsReopenAssessmentResponses, AssessmentsReopenAssessmentErrors, ThrowOnError> => (options.client ?? client).post<AssessmentsReopenAssessmentResponses, AssessmentsReopenAssessmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsReopenAssessmentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}/reopen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rerun Assessment
 */
export const assessmentsRerunAssessment = <ThrowOnError extends boolean = false>(options: Options<AssessmentsRerunAssessmentData, ThrowOnError>): RequestResult<AssessmentsRerunAssessmentResponses, AssessmentsRerunAssessmentErrors, ThrowOnError> => (options.client ?? client).post<AssessmentsRerunAssessmentResponses, AssessmentsRerunAssessmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsRerunAssessmentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}/rerun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Topic Results
 */
export const assessmentsListTopicResults = <ThrowOnError extends boolean = false>(options: Options<AssessmentsListTopicResultsData, ThrowOnError>): RequestResult<AssessmentsListTopicResultsResponses, AssessmentsListTopicResultsErrors, ThrowOnError> => (options.client ?? client).get<AssessmentsListTopicResultsResponses, AssessmentsListTopicResultsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsListTopicResultsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}/results',
    ...options
});

/**
 * Get Topic Result
 */
export const assessmentsGetTopicResult = <ThrowOnError extends boolean = false>(options: Options<AssessmentsGetTopicResultData, ThrowOnError>): RequestResult<AssessmentsGetTopicResultResponses, AssessmentsGetTopicResultErrors, ThrowOnError> => (options.client ?? client).get<AssessmentsGetTopicResultResponses, AssessmentsGetTopicResultErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsGetTopicResultResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}/results/{topic_key}',
    ...options
});

/**
 * Review Topic Result
 */
export const assessmentsReviewTopicResult = <ThrowOnError extends boolean = false>(options: Options<AssessmentsReviewTopicResultData, ThrowOnError>): RequestResult<AssessmentsReviewTopicResultResponses, AssessmentsReviewTopicResultErrors, ThrowOnError> => (options.client ?? client).post<AssessmentsReviewTopicResultResponses, AssessmentsReviewTopicResultErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsReviewTopicResultResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}/results/{topic_key}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Version Impact
 */
export const assessmentsGetVersionImpact = <ThrowOnError extends boolean = false>(options: Options<AssessmentsGetVersionImpactData, ThrowOnError>): RequestResult<AssessmentsGetVersionImpactResponses, AssessmentsGetVersionImpactErrors, ThrowOnError> => (options.client ?? client).get<AssessmentsGetVersionImpactResponses, AssessmentsGetVersionImpactErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssessmentsGetVersionImpactResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assessments/{assessment_uid}/version-impact',
    ...options
});

/**
 * Create Answer
 */
export const assistantCreateAnswer = <ThrowOnError extends boolean = false>(options: Options<AssistantCreateAnswerData, ThrowOnError, unknown>): Promise<ServerSentEventsResult<AssistantCreateAnswerResponses>> => (options.client ?? client).sse.post<AssistantCreateAnswerResponses, AssistantCreateAnswerErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assistant/answers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Budget
 */
export const assistantGetBudget = <ThrowOnError extends boolean = false>(options?: Options<AssistantGetBudgetData, ThrowOnError>): RequestResult<AssistantGetBudgetResponses, AssistantGetBudgetErrors, ThrowOnError> => (options?.client ?? client).get<AssistantGetBudgetResponses, AssistantGetBudgetErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssistantGetBudgetResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assistant/budget',
    ...options
});

/**
 * List Suggestions
 */
export const assistantListSuggestions = <ThrowOnError extends boolean = false>(options?: Options<AssistantListSuggestionsData, ThrowOnError>): RequestResult<AssistantListSuggestionsResponses, AssistantListSuggestionsErrors, ThrowOnError> => (options?.client ?? client).get<AssistantListSuggestionsResponses, AssistantListSuggestionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssistantListSuggestionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assistant/suggestions',
    ...options
});

/**
 * Delete Threads
 */
export const assistantDeleteThreads = <ThrowOnError extends boolean = false>(options?: Options<AssistantDeleteThreadsData, ThrowOnError>): RequestResult<AssistantDeleteThreadsResponses, AssistantDeleteThreadsErrors, ThrowOnError> => (options?.client ?? client).delete<AssistantDeleteThreadsResponses, AssistantDeleteThreadsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssistantDeleteThreadsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assistant/threads',
    ...options
});

/**
 * List Threads
 */
export const assistantListThreads = <ThrowOnError extends boolean = false>(options?: Options<AssistantListThreadsData, ThrowOnError>): RequestResult<AssistantListThreadsResponses, AssistantListThreadsErrors, ThrowOnError> => (options?.client ?? client).get<AssistantListThreadsResponses, AssistantListThreadsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssistantListThreadsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assistant/threads',
    ...options
});

/**
 * Delete Thread
 */
export const assistantDeleteThread = <ThrowOnError extends boolean = false>(options: Options<AssistantDeleteThreadData, ThrowOnError>): RequestResult<AssistantDeleteThreadResponses, AssistantDeleteThreadErrors, ThrowOnError> => (options.client ?? client).delete<AssistantDeleteThreadResponses, AssistantDeleteThreadErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssistantDeleteThreadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assistant/threads/{thread_id}',
    ...options
});

/**
 * Get Thread
 */
export const assistantGetThread = <ThrowOnError extends boolean = false>(options: Options<AssistantGetThreadData, ThrowOnError>): RequestResult<AssistantGetThreadResponses, AssistantGetThreadErrors, ThrowOnError> => (options.client ?? client).get<AssistantGetThreadResponses, AssistantGetThreadErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssistantGetThreadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assistant/threads/{thread_id}',
    ...options
});

/**
 * Rename Thread
 */
export const assistantRenameThread = <ThrowOnError extends boolean = false>(options: Options<AssistantRenameThreadData, ThrowOnError>): RequestResult<AssistantRenameThreadResponses, AssistantRenameThreadErrors, ThrowOnError> => (options.client ?? client).patch<AssistantRenameThreadResponses, AssistantRenameThreadErrors, ThrowOnError>({
    responseValidator: async (data) => await zAssistantRenameThreadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/assistant/threads/{thread_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Invitation
 */
export const authAcceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AuthAcceptInvitationData, ThrowOnError>): RequestResult<AuthAcceptInvitationResponses, AuthAcceptInvitationErrors, ThrowOnError> => (options.client ?? client).post<AuthAcceptInvitationResponses, AuthAcceptInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthAcceptInvitationResponse.parseAsync(data),
    url: '/api/v1/auth/invitations/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Look Up Invitation
 */
export const authLookUpInvitation = <ThrowOnError extends boolean = false>(options: Options<AuthLookUpInvitationData, ThrowOnError>): RequestResult<AuthLookUpInvitationResponses, AuthLookUpInvitationErrors, ThrowOnError> => (options.client ?? client).post<AuthLookUpInvitationResponses, AuthLookUpInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthLookUpInvitationResponse.parseAsync(data),
    url: '/api/v1/auth/invitations/lookup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Authenticator Replacement
 */
export const authStartAuthenticatorReplacement = <ThrowOnError extends boolean = false>(options: Options<AuthStartAuthenticatorReplacementData, ThrowOnError>): RequestResult<AuthStartAuthenticatorReplacementResponses, AuthStartAuthenticatorReplacementErrors, ThrowOnError> => (options.client ?? client).post<AuthStartAuthenticatorReplacementResponses, AuthStartAuthenticatorReplacementErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthStartAuthenticatorReplacementResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/auth/mfa/setup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Authenticator Replacement
 */
export const authConfirmAuthenticatorReplacement = <ThrowOnError extends boolean = false>(options: Options<AuthConfirmAuthenticatorReplacementData, ThrowOnError>): RequestResult<AuthConfirmAuthenticatorReplacementResponses, AuthConfirmAuthenticatorReplacementErrors, ThrowOnError> => (options.client ?? client).post<AuthConfirmAuthenticatorReplacementResponses, AuthConfirmAuthenticatorReplacementErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthConfirmAuthenticatorReplacementResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/auth/mfa/setup/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Auth Options
 */
export const authGetAuthOptions = <ThrowOnError extends boolean = false>(options?: Options<AuthGetAuthOptionsData, ThrowOnError>): RequestResult<AuthGetAuthOptionsResponses, AuthGetAuthOptionsErrors, ThrowOnError> => (options?.client ?? client).get<AuthGetAuthOptionsResponses, AuthGetAuthOptionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthGetAuthOptionsResponse.parseAsync(data),
    url: '/api/v1/auth/options',
    ...options
});

/**
 * Change Password
 */
export const authChangePassword = <ThrowOnError extends boolean = false>(options: Options<AuthChangePasswordData, ThrowOnError>): RequestResult<AuthChangePasswordResponses, AuthChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<AuthChangePasswordResponses, AuthChangePasswordErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthChangePasswordResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/auth/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Password Policy
 */
export const authGetPasswordPolicy = <ThrowOnError extends boolean = false>(options?: Options<AuthGetPasswordPolicyData, ThrowOnError>): RequestResult<AuthGetPasswordPolicyResponses, AuthGetPasswordPolicyErrors, ThrowOnError> => (options?.client ?? client).get<AuthGetPasswordPolicyResponses, AuthGetPasswordPolicyErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthGetPasswordPolicyResponse.parseAsync(data),
    url: '/api/v1/auth/password-policy',
    ...options
});

/**
 * Request Password Reset
 */
export const authRequestPasswordReset = <ThrowOnError extends boolean = false>(options: Options<AuthRequestPasswordResetData, ThrowOnError>): RequestResult<AuthRequestPasswordResetResponses, AuthRequestPasswordResetErrors, ThrowOnError> => (options.client ?? client).post<AuthRequestPasswordResetResponses, AuthRequestPasswordResetErrors, ThrowOnError>({
    url: '/api/v1/auth/password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Password Reset
 */
export const authConfirmPasswordReset = <ThrowOnError extends boolean = false>(options: Options<AuthConfirmPasswordResetData, ThrowOnError>): RequestResult<AuthConfirmPasswordResetResponses, AuthConfirmPasswordResetErrors, ThrowOnError> => (options.client ?? client).post<AuthConfirmPasswordResetResponses, AuthConfirmPasswordResetErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthConfirmPasswordResetResponse.parseAsync(data),
    url: '/api/v1/auth/password-reset/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Look Up Password Reset
 */
export const authLookUpPasswordReset = <ThrowOnError extends boolean = false>(options: Options<AuthLookUpPasswordResetData, ThrowOnError>): RequestResult<AuthLookUpPasswordResetResponses, AuthLookUpPasswordResetErrors, ThrowOnError> => (options.client ?? client).post<AuthLookUpPasswordResetResponses, AuthLookUpPasswordResetErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthLookUpPasswordResetResponse.parseAsync(data),
    url: '/api/v1/auth/password-reset/lookup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Other Sessions
 */
export const authRevokeOtherSessions = <ThrowOnError extends boolean = false>(options?: Options<AuthRevokeOtherSessionsData, ThrowOnError>): RequestResult<AuthRevokeOtherSessionsResponses, AuthRevokeOtherSessionsErrors, ThrowOnError> => (options?.client ?? client).delete<AuthRevokeOtherSessionsResponses, AuthRevokeOtherSessionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthRevokeOtherSessionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/auth/sessions',
    ...options
});

/**
 * List Sessions
 */
export const authListSessions = <ThrowOnError extends boolean = false>(options?: Options<AuthListSessionsData, ThrowOnError>): RequestResult<AuthListSessionsResponses, AuthListSessionsErrors, ThrowOnError> => (options?.client ?? client).get<AuthListSessionsResponses, AuthListSessionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthListSessionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/auth/sessions',
    ...options
});

/**
 * Revoke Session
 */
export const authRevokeSession = <ThrowOnError extends boolean = false>(options: Options<AuthRevokeSessionData, ThrowOnError>): RequestResult<AuthRevokeSessionResponses, AuthRevokeSessionErrors, ThrowOnError> => (options.client ?? client).delete<AuthRevokeSessionResponses, AuthRevokeSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthRevokeSessionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/auth/sessions/{session_id}',
    ...options
});

/**
 * Sign In
 */
export const authSignIn = <ThrowOnError extends boolean = false>(options: Options<AuthSignInData, ThrowOnError>): RequestResult<AuthSignInResponses, AuthSignInErrors, ThrowOnError> => (options.client ?? client).post<AuthSignInResponses, AuthSignInErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthSignInResponse.parseAsync(data),
    url: '/api/v1/auth/sign-in',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Sign In
 */
export const authCompleteSignIn = <ThrowOnError extends boolean = false>(options: Options<AuthCompleteSignInData, ThrowOnError>): RequestResult<AuthCompleteSignInResponses, AuthCompleteSignInErrors, ThrowOnError> => (options.client ?? client).post<AuthCompleteSignInResponses, AuthCompleteSignInErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthCompleteSignInResponse.parseAsync(data),
    url: '/api/v1/auth/sign-in/code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Setup
 */
export const authStartSetup = <ThrowOnError extends boolean = false>(options?: Options<AuthStartSetupData, ThrowOnError>): RequestResult<AuthStartSetupResponses, AuthStartSetupErrors, ThrowOnError> => (options?.client ?? client).post<AuthStartSetupResponses, AuthStartSetupErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthStartSetupResponse.parseAsync(data),
    url: '/api/v1/auth/sign-in/setup',
    ...options
});

/**
 * Confirm Setup
 */
export const authConfirmSetup = <ThrowOnError extends boolean = false>(options: Options<AuthConfirmSetupData, ThrowOnError>): RequestResult<AuthConfirmSetupResponses, AuthConfirmSetupErrors, ThrowOnError> => (options.client ?? client).post<AuthConfirmSetupResponses, AuthConfirmSetupErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthConfirmSetupResponse.parseAsync(data),
    url: '/api/v1/auth/sign-in/setup/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign Out
 */
export const authSignOut = <ThrowOnError extends boolean = false>(options?: Options<AuthSignOutData, ThrowOnError>): RequestResult<AuthSignOutResponses, AuthSignOutErrors, ThrowOnError> => (options?.client ?? client).post<AuthSignOutResponses, AuthSignOutErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthSignOutResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/auth/sign-out',
    ...options
});

/**
 * List Authorities
 */
export const catalogListAuthorities = <ThrowOnError extends boolean = false>(options?: Options<CatalogListAuthoritiesData, ThrowOnError>): RequestResult<CatalogListAuthoritiesResponses, CatalogListAuthoritiesErrors, ThrowOnError> => (options?.client ?? client).get<CatalogListAuthoritiesResponses, CatalogListAuthoritiesErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogListAuthoritiesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/authorities',
    ...options
});

/**
 * List Bands
 */
export const curvesListBands = <ThrowOnError extends boolean = false>(options: Options<CurvesListBandsData, ThrowOnError>): RequestResult<CurvesListBandsResponses, CurvesListBandsErrors, ThrowOnError> => (options.client ?? client).get<CurvesListBandsResponses, CurvesListBandsErrors, ThrowOnError>({
    responseValidator: async (data) => await zCurvesListBandsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/bands',
    ...options
});

/**
 * List Capability Documents
 */
export const capabilitiesListCapabilityDocuments = <ThrowOnError extends boolean = false>(options?: Options<CapabilitiesListCapabilityDocumentsData, ThrowOnError>): RequestResult<CapabilitiesListCapabilityDocumentsResponses, CapabilitiesListCapabilityDocumentsErrors, ThrowOnError> => (options?.client ?? client).get<CapabilitiesListCapabilityDocumentsResponses, CapabilitiesListCapabilityDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesListCapabilityDocumentsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents',
    ...options
});

/**
 * Create Capability Upload
 */
export const capabilitiesCreateCapabilityUpload = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesCreateCapabilityUploadData, ThrowOnError>): RequestResult<CapabilitiesCreateCapabilityUploadResponses, CapabilitiesCreateCapabilityUploadErrors, ThrowOnError> => (options.client ?? client).post<CapabilitiesCreateCapabilityUploadResponses, CapabilitiesCreateCapabilityUploadErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesCreateCapabilityUploadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/uploads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Capability Upload
 */
export const capabilitiesDeleteCapabilityUpload = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesDeleteCapabilityUploadData, ThrowOnError>): RequestResult<CapabilitiesDeleteCapabilityUploadResponses, CapabilitiesDeleteCapabilityUploadErrors, ThrowOnError> => (options.client ?? client).delete<CapabilitiesDeleteCapabilityUploadResponses, CapabilitiesDeleteCapabilityUploadErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesDeleteCapabilityUploadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/uploads/{upload_id}',
    ...options
});

/**
 * Get Capability Upload
 */
export const capabilitiesGetCapabilityUpload = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesGetCapabilityUploadData, ThrowOnError>): RequestResult<CapabilitiesGetCapabilityUploadResponses, CapabilitiesGetCapabilityUploadErrors, ThrowOnError> => (options.client ?? client).get<CapabilitiesGetCapabilityUploadResponses, CapabilitiesGetCapabilityUploadErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesGetCapabilityUploadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/uploads/{upload_id}',
    ...options
});

/**
 * Complete Capability Upload
 */
export const capabilitiesCompleteCapabilityUpload = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesCompleteCapabilityUploadData, ThrowOnError>): RequestResult<CapabilitiesCompleteCapabilityUploadResponses, CapabilitiesCompleteCapabilityUploadErrors, ThrowOnError> => (options.client ?? client).post<CapabilitiesCompleteCapabilityUploadResponses, CapabilitiesCompleteCapabilityUploadErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesCompleteCapabilityUploadResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/uploads/{upload_id}/complete',
    ...options
});

/**
 * Put Capability Upload Part
 */
export const capabilitiesPutCapabilityUploadPart = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesPutCapabilityUploadPartData, ThrowOnError>): RequestResult<CapabilitiesPutCapabilityUploadPartResponses, CapabilitiesPutCapabilityUploadPartErrors, ThrowOnError> => (options.client ?? client).put<CapabilitiesPutCapabilityUploadPartResponses, CapabilitiesPutCapabilityUploadPartErrors, ThrowOnError>({
    bodySerializer: null,
    responseValidator: async (data) => await zCapabilitiesPutCapabilityUploadPartResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/uploads/{upload_id}/parts/{part_number}',
    ...options,
    headers: {
        'Content-Type': 'application/octet-stream',
        ...options.headers
    }
});

/**
 * Delete Capability Document
 */
export const capabilitiesDeleteCapabilityDocument = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesDeleteCapabilityDocumentData, ThrowOnError>): RequestResult<CapabilitiesDeleteCapabilityDocumentResponses, CapabilitiesDeleteCapabilityDocumentErrors, ThrowOnError> => (options.client ?? client).delete<CapabilitiesDeleteCapabilityDocumentResponses, CapabilitiesDeleteCapabilityDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesDeleteCapabilityDocumentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/{capability_doc_uid}',
    ...options
});

/**
 * Get Capability Document
 */
export const capabilitiesGetCapabilityDocument = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesGetCapabilityDocumentData, ThrowOnError>): RequestResult<CapabilitiesGetCapabilityDocumentResponses, CapabilitiesGetCapabilityDocumentErrors, ThrowOnError> => (options.client ?? client).get<CapabilitiesGetCapabilityDocumentResponses, CapabilitiesGetCapabilityDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesGetCapabilityDocumentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/{capability_doc_uid}',
    ...options
});

/**
 * List Capabilities
 */
export const capabilitiesListCapabilities = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesListCapabilitiesData, ThrowOnError>): RequestResult<CapabilitiesListCapabilitiesResponses, CapabilitiesListCapabilitiesErrors, ThrowOnError> => (options.client ?? client).get<CapabilitiesListCapabilitiesResponses, CapabilitiesListCapabilitiesErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesListCapabilitiesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/{capability_doc_uid}/capabilities',
    ...options
});

/**
 * Extract Capability Document
 */
export const capabilitiesExtractCapabilityDocument = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesExtractCapabilityDocumentData, ThrowOnError>): RequestResult<CapabilitiesExtractCapabilityDocumentResponses, CapabilitiesExtractCapabilityDocumentErrors, ThrowOnError> => (options.client ?? client).post<CapabilitiesExtractCapabilityDocumentResponses, CapabilitiesExtractCapabilityDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesExtractCapabilityDocumentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/{capability_doc_uid}/extract',
    ...options
});

/**
 * Get Capability Document Pdf
 */
export const capabilitiesGetCapabilityDocumentPdf = <ThrowOnError extends boolean = false>(options: Options<CapabilitiesGetCapabilityDocumentPdfData, ThrowOnError>): RequestResult<CapabilitiesGetCapabilityDocumentPdfResponses, CapabilitiesGetCapabilityDocumentPdfErrors, ThrowOnError> => (options.client ?? client).get<CapabilitiesGetCapabilityDocumentPdfResponses, CapabilitiesGetCapabilityDocumentPdfErrors, ThrowOnError>({
    responseValidator: async (data) => await zCapabilitiesGetCapabilityDocumentPdfResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/capability-documents/{capability_doc_uid}/pdf',
    ...options
});

/**
 * List Clauses
 */
export const clausesListClauses = <ThrowOnError extends boolean = false>(options: Options<ClausesListClausesData, ThrowOnError>): RequestResult<ClausesListClausesResponses, ClausesListClausesErrors, ThrowOnError> => (options.client ?? client).get<ClausesListClausesResponses, ClausesListClausesErrors, ThrowOnError>({
    responseValidator: async (data) => await zClausesListClausesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/clauses',
    ...options
});

/**
 * Get Clause
 */
export const clausesGetClause = <ThrowOnError extends boolean = false>(options: Options<ClausesGetClauseData, ThrowOnError>): RequestResult<ClausesGetClauseResponses, ClausesGetClauseErrors, ThrowOnError> => (options.client ?? client).get<ClausesGetClauseResponses, ClausesGetClauseErrors, ThrowOnError>({
    responseValidator: async (data) => await zClausesGetClauseResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/clauses/{clause_uid}',
    ...options
});

/**
 * List Curves
 */
export const curvesListCurves = <ThrowOnError extends boolean = false>(options: Options<CurvesListCurvesData, ThrowOnError>): RequestResult<CurvesListCurvesResponses, CurvesListCurvesErrors, ThrowOnError> => (options.client ?? client).get<CurvesListCurvesResponses, CurvesListCurvesErrors, ThrowOnError>({
    responseValidator: async (data) => await zCurvesListCurvesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/curves',
    ...options
});

/**
 * Get Curve Facets
 */
export const curvesGetCurveFacets = <ThrowOnError extends boolean = false>(options: Options<CurvesGetCurveFacetsData, ThrowOnError>): RequestResult<CurvesGetCurveFacetsResponses, CurvesGetCurveFacetsErrors, ThrowOnError> => (options.client ?? client).get<CurvesGetCurveFacetsResponses, CurvesGetCurveFacetsErrors, ThrowOnError>({
    responseValidator: async (data) => await zCurvesGetCurveFacetsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/curves/facets',
    ...options
});

/**
 * Get Curve
 */
export const curvesGetCurve = <ThrowOnError extends boolean = false>(options: Options<CurvesGetCurveData, ThrowOnError>): RequestResult<CurvesGetCurveResponses, CurvesGetCurveErrors, ThrowOnError> => (options.client ?? client).get<CurvesGetCurveResponses, CurvesGetCurveErrors, ThrowOnError>({
    responseValidator: async (data) => await zCurvesGetCurveResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/curves/{curve_uid}',
    ...options
});

/**
 * List Definitions
 */
export const vocabularyListDefinitions = <ThrowOnError extends boolean = false>(options: Options<VocabularyListDefinitionsData, ThrowOnError>): RequestResult<VocabularyListDefinitionsResponses, VocabularyListDefinitionsErrors, ThrowOnError> => (options.client ?? client).get<VocabularyListDefinitionsResponses, VocabularyListDefinitionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zVocabularyListDefinitionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/definitions',
    ...options
});

/**
 * Lookup Definition
 */
export const vocabularyLookupDefinition = <ThrowOnError extends boolean = false>(options: Options<VocabularyLookupDefinitionData, ThrowOnError>): RequestResult<VocabularyLookupDefinitionResponses, VocabularyLookupDefinitionErrors, ThrowOnError> => (options.client ?? client).get<VocabularyLookupDefinitionResponses, VocabularyLookupDefinitionErrors, ThrowOnError>({
    responseValidator: async (data) => await zVocabularyLookupDefinitionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/definitions/lookup',
    ...options
});

/**
 * Get Definition
 */
export const vocabularyGetDefinition = <ThrowOnError extends boolean = false>(options: Options<VocabularyGetDefinitionData, ThrowOnError>): RequestResult<VocabularyGetDefinitionResponses, VocabularyGetDefinitionErrors, ThrowOnError> => (options.client ?? client).get<VocabularyGetDefinitionResponses, VocabularyGetDefinitionErrors, ThrowOnError>({
    responseValidator: async (data) => await zVocabularyGetDefinitionResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/definitions/{definition_uid}',
    ...options
});

/**
 * List Documents
 */
export const catalogListDocuments = <ThrowOnError extends boolean = false>(options?: Options<CatalogListDocumentsData, ThrowOnError>): RequestResult<CatalogListDocumentsResponses, CatalogListDocumentsErrors, ThrowOnError> => (options?.client ?? client).get<CatalogListDocumentsResponses, CatalogListDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogListDocumentsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents',
    ...options
});

/**
 * Get Document
 */
export const catalogGetDocument = <ThrowOnError extends boolean = false>(options: Options<CatalogGetDocumentData, ThrowOnError>): RequestResult<CatalogGetDocumentResponses, CatalogGetDocumentErrors, ThrowOnError> => (options.client ?? client).get<CatalogGetDocumentResponses, CatalogGetDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogGetDocumentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}',
    ...options
});

/**
 * Get Document Audit
 */
export const operationsGetDocumentAudit = <ThrowOnError extends boolean = false>(options: Options<OperationsGetDocumentAuditData, ThrowOnError>): RequestResult<OperationsGetDocumentAuditResponses, OperationsGetDocumentAuditErrors, ThrowOnError> => (options.client ?? client).get<OperationsGetDocumentAuditResponses, OperationsGetDocumentAuditErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsGetDocumentAuditResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/audit',
    ...options
});

/**
 * List Charts
 */
export const curvesListCharts = <ThrowOnError extends boolean = false>(options: Options<CurvesListChartsData, ThrowOnError>): RequestResult<CurvesListChartsResponses, CurvesListChartsErrors, ThrowOnError> => (options.client ?? client).get<CurvesListChartsResponses, CurvesListChartsErrors, ThrowOnError>({
    responseValidator: async (data) => await zCurvesListChartsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/charts',
    ...options
});

/**
 * Get Chart
 */
export const curvesGetChart = <ThrowOnError extends boolean = false>(options: Options<CurvesGetChartData, ThrowOnError>): RequestResult<CurvesGetChartResponses, CurvesGetChartErrors, ThrowOnError> => (options.client ?? client).get<CurvesGetChartResponses, CurvesGetChartErrors, ThrowOnError>({
    responseValidator: async (data) => await zCurvesGetChartResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/charts/{chart_key}',
    ...options
});

/**
 * List Completeness Gaps
 */
export const operationsListCompletenessGaps = <ThrowOnError extends boolean = false>(options: Options<OperationsListCompletenessGapsData, ThrowOnError>): RequestResult<OperationsListCompletenessGapsResponses, OperationsListCompletenessGapsErrors, ThrowOnError> => (options.client ?? client).get<OperationsListCompletenessGapsResponses, OperationsListCompletenessGapsErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsListCompletenessGapsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/completeness',
    ...options
});

/**
 * Get Confidence Histogram
 */
export const operationsGetConfidenceHistogram = <ThrowOnError extends boolean = false>(options: Options<OperationsGetConfidenceHistogramData, ThrowOnError>): RequestResult<OperationsGetConfidenceHistogramResponses, OperationsGetConfidenceHistogramErrors, ThrowOnError> => (options.client ?? client).get<OperationsGetConfidenceHistogramResponses, OperationsGetConfidenceHistogramErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsGetConfidenceHistogramResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/confidence',
    ...options
});

/**
 * List Figures
 */
export const catalogListFigures = <ThrowOnError extends boolean = false>(options: Options<CatalogListFiguresData, ThrowOnError>): RequestResult<CatalogListFiguresResponses, CatalogListFiguresErrors, ThrowOnError> => (options.client ?? client).get<CatalogListFiguresResponses, CatalogListFiguresErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogListFiguresResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/figures',
    ...options
});

/**
 * Get Figure Image
 */
export const sourcesGetFigureImage = <ThrowOnError extends boolean = false>(options: Options<SourcesGetFigureImageData, ThrowOnError>): RequestResult<SourcesGetFigureImageResponses, SourcesGetFigureImageErrors, ThrowOnError> => (options.client ?? client).get<SourcesGetFigureImageResponses, SourcesGetFigureImageErrors, ThrowOnError>({
    responseValidator: async (data) => await zSourcesGetFigureImageResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/figures/{figure_key}/image',
    ...options
});

/**
 * Get Document Integrity
 */
export const operationsGetDocumentIntegrity = <ThrowOnError extends boolean = false>(options: Options<OperationsGetDocumentIntegrityData, ThrowOnError>): RequestResult<OperationsGetDocumentIntegrityResponses, OperationsGetDocumentIntegrityErrors, ThrowOnError> => (options.client ?? client).get<OperationsGetDocumentIntegrityResponses, OperationsGetDocumentIntegrityErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsGetDocumentIntegrityResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/integrity',
    ...options
});

/**
 * List Page Clauses
 */
export const clausesListPageClauses = <ThrowOnError extends boolean = false>(options: Options<ClausesListPageClausesData, ThrowOnError>): RequestResult<ClausesListPageClausesResponses, ClausesListPageClausesErrors, ThrowOnError> => (options.client ?? client).get<ClausesListPageClausesResponses, ClausesListPageClausesErrors, ThrowOnError>({
    responseValidator: async (data) => await zClausesListPageClausesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/pages/{page}/clauses',
    ...options
});

/**
 * Get Page Highlights
 */
export const sourcesGetPageHighlights = <ThrowOnError extends boolean = false>(options: Options<SourcesGetPageHighlightsData, ThrowOnError>): RequestResult<SourcesGetPageHighlightsResponses, SourcesGetPageHighlightsErrors, ThrowOnError> => (options.client ?? client).get<SourcesGetPageHighlightsResponses, SourcesGetPageHighlightsErrors, ThrowOnError>({
    responseValidator: async (data) => await zSourcesGetPageHighlightsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/pages/{page}/highlights',
    ...options
});

/**
 * Locate Texts
 */
export const sourcesLocateTexts = <ThrowOnError extends boolean = false>(options: Options<SourcesLocateTextsData, ThrowOnError>): RequestResult<SourcesLocateTextsResponses, SourcesLocateTextsErrors, ThrowOnError> => (options.client ?? client).post<SourcesLocateTextsResponses, SourcesLocateTextsErrors, ThrowOnError>({
    responseValidator: async (data) => await zSourcesLocateTextsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/pages/{page}/locate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Document Pdf
 */
export const sourcesGetDocumentPdf = <ThrowOnError extends boolean = false>(options: Options<SourcesGetDocumentPdfData, ThrowOnError>): RequestResult<SourcesGetDocumentPdfResponses, SourcesGetDocumentPdfErrors, ThrowOnError> => (options.client ?? client).get<SourcesGetDocumentPdfResponses, SourcesGetDocumentPdfErrors, ThrowOnError>({
    responseValidator: async (data) => await zSourcesGetDocumentPdfResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/pdf',
    ...options
});

/**
 * Promote Document
 */
export const lifecyclePromoteDocument = <ThrowOnError extends boolean = false>(options: Options<LifecyclePromoteDocumentData, ThrowOnError>): RequestResult<LifecyclePromoteDocumentResponses, LifecyclePromoteDocumentErrors, ThrowOnError> => (options.client ?? client).post<LifecyclePromoteDocumentResponses, LifecyclePromoteDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zLifecyclePromoteDocumentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/promote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Standards
 */
export const catalogListStandards = <ThrowOnError extends boolean = false>(options: Options<CatalogListStandardsData, ThrowOnError>): RequestResult<CatalogListStandardsResponses, CatalogListStandardsErrors, ThrowOnError> => (options.client ?? client).get<CatalogListStandardsResponses, CatalogListStandardsErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogListStandardsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/standards',
    ...options
});

/**
 * Get Document Stats
 */
export const catalogGetDocumentStats = <ThrowOnError extends boolean = false>(options: Options<CatalogGetDocumentStatsData, ThrowOnError>): RequestResult<CatalogGetDocumentStatsResponses, CatalogGetDocumentStatsErrors, ThrowOnError> => (options.client ?? client).get<CatalogGetDocumentStatsResponses, CatalogGetDocumentStatsErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogGetDocumentStatsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/stats',
    ...options
});

/**
 * Set Document Status
 */
export const lifecycleSetDocumentStatus = <ThrowOnError extends boolean = false>(options: Options<LifecycleSetDocumentStatusData, ThrowOnError>): RequestResult<LifecycleSetDocumentStatusResponses, LifecycleSetDocumentStatusErrors, ThrowOnError> => (options.client ?? client).post<LifecycleSetDocumentStatusResponses, LifecycleSetDocumentStatusErrors, ThrowOnError>({
    responseValidator: async (data) => await zLifecycleSetDocumentStatusResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Tables
 */
export const catalogListTables = <ThrowOnError extends boolean = false>(options: Options<CatalogListTablesData, ThrowOnError>): RequestResult<CatalogListTablesResponses, CatalogListTablesErrors, ThrowOnError> => (options.client ?? client).get<CatalogListTablesResponses, CatalogListTablesErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogListTablesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/tables',
    ...options
});

/**
 * Get Table
 */
export const catalogGetTable = <ThrowOnError extends boolean = false>(options: Options<CatalogGetTableData, ThrowOnError>): RequestResult<CatalogGetTableResponses, CatalogGetTableErrors, ThrowOnError> => (options.client ?? client).get<CatalogGetTableResponses, CatalogGetTableErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogGetTableResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/tables/{table_key}',
    ...options
});

/**
 * List Thresholds
 */
export const catalogListThresholds = <ThrowOnError extends boolean = false>(options: Options<CatalogListThresholdsData, ThrowOnError>): RequestResult<CatalogListThresholdsResponses, CatalogListThresholdsErrors, ThrowOnError> => (options.client ?? client).get<CatalogListThresholdsResponses, CatalogListThresholdsErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogListThresholdsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/thresholds',
    ...options
});

/**
 * Get Toc
 */
export const clausesGetToc = <ThrowOnError extends boolean = false>(options: Options<ClausesGetTocData, ThrowOnError>): RequestResult<ClausesGetTocResponses, ClausesGetTocErrors, ThrowOnError> => (options.client ?? client).get<ClausesGetTocResponses, ClausesGetTocErrors, ThrowOnError>({
    responseValidator: async (data) => await zClausesGetTocResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/documents/{doc_uid}/toc',
    ...options
});

/**
 * List Evaluations
 */
export const operationsListEvaluations = <ThrowOnError extends boolean = false>(options?: Options<OperationsListEvaluationsData, ThrowOnError>): RequestResult<OperationsListEvaluationsResponses, OperationsListEvaluationsErrors, ThrowOnError> => (options?.client ?? client).get<OperationsListEvaluationsResponses, OperationsListEvaluationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsListEvaluationsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/evaluations',
    ...options
});

/**
 * Export Requirements Csv
 */
export const exportsExportRequirementsCsv = <ThrowOnError extends boolean = false>(options: Options<ExportsExportRequirementsCsvData, ThrowOnError>): RequestResult<ExportsExportRequirementsCsvResponses, ExportsExportRequirementsCsvErrors, ThrowOnError> => (options.client ?? client).get<ExportsExportRequirementsCsvResponses, ExportsExportRequirementsCsvErrors, ThrowOnError>({
    responseValidator: async (data) => await zExportsExportRequirementsCsvResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/exports/requirements.csv',
    ...options
});

/**
 * Export Requirements Xlsx
 */
export const exportsExportRequirementsXlsx = <ThrowOnError extends boolean = false>(options: Options<ExportsExportRequirementsXlsxData, ThrowOnError>): RequestResult<ExportsExportRequirementsXlsxResponses, ExportsExportRequirementsXlsxErrors, ThrowOnError> => (options.client ?? client).get<ExportsExportRequirementsXlsxResponses, ExportsExportRequirementsXlsxErrors, ThrowOnError>({
    responseValidator: async (data) => await zExportsExportRequirementsXlsxResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/exports/requirements.xlsx',
    ...options
});

/**
 * List Families
 */
export const catalogListFamilies = <ThrowOnError extends boolean = false>(options?: Options<CatalogListFamiliesData, ThrowOnError>): RequestResult<CatalogListFamiliesResponses, CatalogListFamiliesErrors, ThrowOnError> => (options?.client ?? client).get<CatalogListFamiliesResponses, CatalogListFamiliesErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogListFamiliesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/families',
    ...options
});

/**
 * Get Current Document
 */
export const catalogGetCurrentDocument = <ThrowOnError extends boolean = false>(options: Options<CatalogGetCurrentDocumentData, ThrowOnError>): RequestResult<CatalogGetCurrentDocumentResponses, CatalogGetCurrentDocumentErrors, ThrowOnError> => (options.client ?? client).get<CatalogGetCurrentDocumentResponses, CatalogGetCurrentDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zCatalogGetCurrentDocumentResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/families/{family_id}/current',
    ...options
});

/**
 * List Family Versions
 */
export const lifecycleListFamilyVersions = <ThrowOnError extends boolean = false>(options: Options<LifecycleListFamilyVersionsData, ThrowOnError>): RequestResult<LifecycleListFamilyVersionsResponses, LifecycleListFamilyVersionsErrors, ThrowOnError> => (options.client ?? client).get<LifecycleListFamilyVersionsResponses, LifecycleListFamilyVersionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zLifecycleListFamilyVersionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/families/{family_id}/versions',
    ...options
});

/**
 * Send Feedback
 */
export const feedbackSendFeedback = <ThrowOnError extends boolean = false>(options: Options<FeedbackSendFeedbackData, ThrowOnError>): RequestResult<FeedbackSendFeedbackResponses, FeedbackSendFeedbackErrors, ThrowOnError> => (options.client ?? client).post<FeedbackSendFeedbackResponses, FeedbackSendFeedbackErrors, ThrowOnError>({
    responseValidator: async (data) => await zFeedbackSendFeedbackResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Jobs
 */
export const jobsListJobs = <ThrowOnError extends boolean = false>(options?: Options<JobsListJobsData, ThrowOnError>): RequestResult<JobsListJobsResponses, JobsListJobsErrors, ThrowOnError> => (options?.client ?? client).get<JobsListJobsResponses, JobsListJobsErrors, ThrowOnError>({
    responseValidator: async (data) => await zJobsListJobsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/jobs',
    ...options
});

/**
 * Create Job
 */
export const jobsCreateJob = <ThrowOnError extends boolean = false>(options: Options<JobsCreateJobData, ThrowOnError>): RequestResult<JobsCreateJobResponses, JobsCreateJobErrors, ThrowOnError> => (options.client ?? client).post<JobsCreateJobResponses, JobsCreateJobErrors, ThrowOnError>({
    responseValidator: async (data) => await zJobsCreateJobResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Active Job Count
 */
export const jobsGetActiveJobCount = <ThrowOnError extends boolean = false>(options?: Options<JobsGetActiveJobCountData, ThrowOnError>): RequestResult<JobsGetActiveJobCountResponses, JobsGetActiveJobCountErrors, ThrowOnError> => (options?.client ?? client).get<JobsGetActiveJobCountResponses, JobsGetActiveJobCountErrors, ThrowOnError>({
    responseValidator: async (data) => await zJobsGetActiveJobCountResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/jobs/active-count',
    ...options
});

/**
 * Get Job Capacity
 */
export const jobsGetJobCapacity = <ThrowOnError extends boolean = false>(options?: Options<JobsGetJobCapacityData, ThrowOnError>): RequestResult<JobsGetJobCapacityResponses, JobsGetJobCapacityErrors, ThrowOnError> => (options?.client ?? client).get<JobsGetJobCapacityResponses, JobsGetJobCapacityErrors, ThrowOnError>({
    responseValidator: async (data) => await zJobsGetJobCapacityResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/jobs/capacity',
    ...options
});

/**
 * Get Job Estimate
 */
export const jobsGetJobEstimate = <ThrowOnError extends boolean = false>(options: Options<JobsGetJobEstimateData, ThrowOnError>): RequestResult<JobsGetJobEstimateResponses, JobsGetJobEstimateErrors, ThrowOnError> => (options.client ?? client).get<JobsGetJobEstimateResponses, JobsGetJobEstimateErrors, ThrowOnError>({
    responseValidator: async (data) => await zJobsGetJobEstimateResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/jobs/estimate',
    ...options
});

/**
 * Get Job
 */
export const jobsGetJob = <ThrowOnError extends boolean = false>(options: Options<JobsGetJobData, ThrowOnError>): RequestResult<JobsGetJobResponses, JobsGetJobErrors, ThrowOnError> => (options.client ?? client).get<JobsGetJobResponses, JobsGetJobErrors, ThrowOnError>({
    responseValidator: async (data) => await zJobsGetJobResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/jobs/{job_id}',
    ...options
});

/**
 * Cancel Job
 */
export const jobsCancelJob = <ThrowOnError extends boolean = false>(options: Options<JobsCancelJobData, ThrowOnError>): RequestResult<JobsCancelJobResponses, JobsCancelJobErrors, ThrowOnError> => (options.client ?? client).post<JobsCancelJobResponses, JobsCancelJobErrors, ThrowOnError>({
    responseValidator: async (data) => await zJobsCancelJobResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/jobs/{job_id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream Job Events
 */
export const jobsStreamJobEvents = <ThrowOnError extends boolean = false>(options: Options<JobsStreamJobEventsData, ThrowOnError, unknown>): Promise<ServerSentEventsResult<JobsStreamJobEventsResponses>> => (options.client ?? client).sse.get<JobsStreamJobEventsResponses, JobsStreamJobEventsErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/jobs/{job_id}/events',
    ...options
});

/**
 * List Jurisdictions
 */
export const metaListJurisdictions = <ThrowOnError extends boolean = false>(options?: Options<MetaListJurisdictionsData, ThrowOnError>): RequestResult<MetaListJurisdictionsResponses, MetaListJurisdictionsErrors, ThrowOnError> => (options?.client ?? client).get<MetaListJurisdictionsResponses, MetaListJurisdictionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zMetaListJurisdictionsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/jurisdictions',
    ...options
});

/**
 * Get Me
 */
export const metaGetMe = <ThrowOnError extends boolean = false>(options?: Options<MetaGetMeData, ThrowOnError>): RequestResult<MetaGetMeResponses, MetaGetMeErrors, ThrowOnError> => (options?.client ?? client).get<MetaGetMeResponses, MetaGetMeErrors, ThrowOnError>({
    responseValidator: async (data) => await zMetaGetMeResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/me',
    ...options
});

/**
 * List Entries
 */
export const whatsNewListEntries = <ThrowOnError extends boolean = false>(options?: Options<WhatsNewListEntriesData, ThrowOnError>): RequestResult<WhatsNewListEntriesResponses, WhatsNewListEntriesErrors, ThrowOnError> => (options?.client ?? client).get<WhatsNewListEntriesResponses, WhatsNewListEntriesErrors, ThrowOnError>({
    responseValidator: async (data) => await zWhatsNewListEntriesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/me/whats-new',
    ...options
});

/**
 * Mark Seen
 */
export const whatsNewMarkSeen = <ThrowOnError extends boolean = false>(options: Options<WhatsNewMarkSeenData, ThrowOnError>): RequestResult<WhatsNewMarkSeenResponses, WhatsNewMarkSeenErrors, ThrowOnError> => (options.client ?? client).post<WhatsNewMarkSeenResponses, WhatsNewMarkSeenErrors, ThrowOnError>({
    responseValidator: async (data) => await zWhatsNewMarkSeenResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/me/whats-new/seen',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Meta
 */
export const metaGetMeta = <ThrowOnError extends boolean = false>(options?: Options<MetaGetMetaData, ThrowOnError>): RequestResult<MetaGetMetaResponses, MetaGetMetaErrors, ThrowOnError> => (options?.client ?? client).get<MetaGetMetaResponses, MetaGetMetaErrors, ThrowOnError>({
    responseValidator: async (data) => await zMetaGetMetaResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/meta',
    ...options
});

/**
 * List Parameter Groups
 */
export const vocabularyListParameterGroups = <ThrowOnError extends boolean = false>(options?: Options<VocabularyListParameterGroupsData, ThrowOnError>): RequestResult<VocabularyListParameterGroupsResponses, VocabularyListParameterGroupsErrors, ThrowOnError> => (options?.client ?? client).get<VocabularyListParameterGroupsResponses, VocabularyListParameterGroupsErrors, ThrowOnError>({
    responseValidator: async (data) => await zVocabularyListParameterGroupsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/parameter-groups',
    ...options
});

/**
 * List Parameters
 */
export const vocabularyListParameters = <ThrowOnError extends boolean = false>(options?: Options<VocabularyListParametersData, ThrowOnError>): RequestResult<VocabularyListParametersResponses, VocabularyListParametersErrors, ThrowOnError> => (options?.client ?? client).get<VocabularyListParametersResponses, VocabularyListParametersErrors, ThrowOnError>({
    responseValidator: async (data) => await zVocabularyListParametersResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/parameters',
    ...options
});

/**
 * Get Parameter
 */
export const vocabularyGetParameter = <ThrowOnError extends boolean = false>(options: Options<VocabularyGetParameterData, ThrowOnError>): RequestResult<VocabularyGetParameterResponses, VocabularyGetParameterErrors, ThrowOnError> => (options.client ?? client).get<VocabularyGetParameterResponses, VocabularyGetParameterErrors, ThrowOnError>({
    responseValidator: async (data) => await zVocabularyGetParameterResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/parameters/{parameter_id}',
    ...options
});

/**
 * List Parameter Markets
 */
export const vocabularyListParameterMarkets = <ThrowOnError extends boolean = false>(options: Options<VocabularyListParameterMarketsData, ThrowOnError>): RequestResult<VocabularyListParameterMarketsResponses, VocabularyListParameterMarketsErrors, ThrowOnError> => (options.client ?? client).get<VocabularyListParameterMarketsResponses, VocabularyListParameterMarketsErrors, ThrowOnError>({
    responseValidator: async (data) => await zVocabularyListParameterMarketsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/parameters/{parameter_id}/markets',
    ...options
});

/**
 * List Requirements
 */
export const requirementsListRequirements = <ThrowOnError extends boolean = false>(options: Options<RequirementsListRequirementsData, ThrowOnError>): RequestResult<RequirementsListRequirementsResponses, RequirementsListRequirementsErrors, ThrowOnError> => (options.client ?? client).get<RequirementsListRequirementsResponses, RequirementsListRequirementsErrors, ThrowOnError>({
    responseValidator: async (data) => await zRequirementsListRequirementsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/requirements',
    ...options
});

/**
 * Get Requirement Facets
 */
export const requirementsGetRequirementFacets = <ThrowOnError extends boolean = false>(options: Options<RequirementsGetRequirementFacetsData, ThrowOnError>): RequestResult<RequirementsGetRequirementFacetsResponses, RequirementsGetRequirementFacetsErrors, ThrowOnError> => (options.client ?? client).get<RequirementsGetRequirementFacetsResponses, RequirementsGetRequirementFacetsErrors, ThrowOnError>({
    responseValidator: async (data) => await zRequirementsGetRequirementFacetsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/requirements/facets',
    ...options
});

/**
 * Get Requirement
 */
export const requirementsGetRequirement = <ThrowOnError extends boolean = false>(options: Options<RequirementsGetRequirementData, ThrowOnError>): RequestResult<RequirementsGetRequirementResponses, RequirementsGetRequirementErrors, ThrowOnError> => (options.client ?? client).get<RequirementsGetRequirementResponses, RequirementsGetRequirementErrors, ThrowOnError>({
    responseValidator: async (data) => await zRequirementsGetRequirementResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/requirements/{req_uid}',
    ...options
});

/**
 * List Runs
 */
export const operationsListRuns = <ThrowOnError extends boolean = false>(options?: Options<OperationsListRunsData, ThrowOnError>): RequestResult<OperationsListRunsResponses, OperationsListRunsErrors, ThrowOnError> => (options?.client ?? client).get<OperationsListRunsResponses, OperationsListRunsErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsListRunsResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/runs',
    ...options
});

/**
 * Get Run
 */
export const operationsGetRun = <ThrowOnError extends boolean = false>(options: Options<OperationsGetRunData, ThrowOnError>): RequestResult<OperationsGetRunResponses, OperationsGetRunErrors, ThrowOnError> => (options.client ?? client).get<OperationsGetRunResponses, OperationsGetRunErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsGetRunResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/runs/{run_uid}',
    ...options
});

/**
 * Get Run Report
 */
export const operationsGetRunReport = <ThrowOnError extends boolean = false>(options: Options<OperationsGetRunReportData, ThrowOnError>): RequestResult<OperationsGetRunReportResponses, OperationsGetRunReportErrors, ThrowOnError> => (options.client ?? client).get<OperationsGetRunReportResponses, OperationsGetRunReportErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsGetRunReportResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/runs/{run_uid}/report',
    ...options
});

/**
 * Get Rollback Impact
 */
export const jobsGetRollbackImpact = <ThrowOnError extends boolean = false>(options: Options<JobsGetRollbackImpactData, ThrowOnError>): RequestResult<JobsGetRollbackImpactResponses, JobsGetRollbackImpactErrors, ThrowOnError> => (options.client ?? client).get<JobsGetRollbackImpactResponses, JobsGetRollbackImpactErrors, ThrowOnError>({
    responseValidator: async (data) => await zJobsGetRollbackImpactResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/runs/{run_uid}/rollback-impact',
    ...options
});

/**
 * Search Clauses
 */
export const searchSearchClauses = <ThrowOnError extends boolean = false>(options: Options<SearchSearchClausesData, ThrowOnError>): RequestResult<SearchSearchClausesResponses, SearchSearchClausesErrors, ThrowOnError> => (options.client ?? client).get<SearchSearchClausesResponses, SearchSearchClausesErrors, ThrowOnError>({
    responseValidator: async (data) => await zSearchSearchClausesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/search',
    ...options
});

/**
 * Get Omnibox
 */
export const searchGetOmnibox = <ThrowOnError extends boolean = false>(options: Options<SearchGetOmniboxData, ThrowOnError>): RequestResult<SearchGetOmniboxResponses, SearchGetOmniboxErrors, ThrowOnError> => (options.client ?? client).get<SearchGetOmniboxResponses, SearchGetOmniboxErrors, ThrowOnError>({
    responseValidator: async (data) => await zSearchGetOmniboxResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/search/omnibox',
    ...options
});

/**
 * List Sources
 */
export const operationsListSources = <ThrowOnError extends boolean = false>(options?: Options<OperationsListSourcesData, ThrowOnError>): RequestResult<OperationsListSourcesResponses, OperationsListSourcesErrors, ThrowOnError> => (options?.client ?? client).get<OperationsListSourcesResponses, OperationsListSourcesErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsListSourcesResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/sources',
    ...options
});

/**
 * Get Source Watch
 */
export const operationsGetSourceWatch = <ThrowOnError extends boolean = false>(options: Options<OperationsGetSourceWatchData, ThrowOnError>): RequestResult<OperationsGetSourceWatchResponses, OperationsGetSourceWatchErrors, ThrowOnError> => (options.client ?? client).get<OperationsGetSourceWatchResponses, OperationsGetSourceWatchErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsGetSourceWatchResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/sources/{family_id}/watch',
    ...options
});

/**
 * Get System Status
 */
export const operationsGetSystemStatus = <ThrowOnError extends boolean = false>(options?: Options<OperationsGetSystemStatusData, ThrowOnError>): RequestResult<OperationsGetSystemStatusResponses, OperationsGetSystemStatusErrors, ThrowOnError> => (options?.client ?? client).get<OperationsGetSystemStatusResponses, OperationsGetSystemStatusErrors, ThrowOnError>({
    responseValidator: async (data) => await zOperationsGetSystemStatusResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/system/status',
    ...options
});

/**
 * Get Version Diff
 */
export const lifecycleGetVersionDiff = <ThrowOnError extends boolean = false>(options: Options<LifecycleGetVersionDiffData, ThrowOnError>): RequestResult<LifecycleGetVersionDiffResponses, LifecycleGetVersionDiffErrors, ThrowOnError> => (options.client ?? client).get<LifecycleGetVersionDiffResponses, LifecycleGetVersionDiffErrors, ThrowOnError>({
    responseValidator: async (data) => await zLifecycleGetVersionDiffResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/versions/diff',
    ...options
});

/**
 * Get Clause Context Diff
 */
export const lifecycleGetClauseContextDiff = <ThrowOnError extends boolean = false>(options: Options<LifecycleGetClauseContextDiffData, ThrowOnError>): RequestResult<LifecycleGetClauseContextDiffResponses, LifecycleGetClauseContextDiffErrors, ThrowOnError> => (options.client ?? client).get<LifecycleGetClauseContextDiffResponses, LifecycleGetClauseContextDiffErrors, ThrowOnError>({
    responseValidator: async (data) => await zLifecycleGetClauseContextDiffResponse.parseAsync(data),
    security: [{
            in: 'cookie',
            name: '__Host-gridcode_session',
            type: 'apiKey'
        }],
    url: '/api/v1/versions/diff/context',
    ...options
});

/**
 * Get Health
 */
export const metaGetHealth = <ThrowOnError extends boolean = false>(options?: Options<MetaGetHealthData, ThrowOnError>): RequestResult<MetaGetHealthResponses, MetaGetHealthErrors, ThrowOnError> => (options?.client ?? client).get<MetaGetHealthResponses, MetaGetHealthErrors, ThrowOnError>({
    responseValidator: async (data) => await zMetaGetHealthResponse.parseAsync(data),
    url: '/healthz',
    ...options
});

/**
 * Get Readiness
 */
export const metaGetReadiness = <ThrowOnError extends boolean = false>(options?: Options<MetaGetReadinessData, ThrowOnError>): RequestResult<MetaGetReadinessResponses, MetaGetReadinessErrors, ThrowOnError> => (options?.client ?? client).get<MetaGetReadinessResponses, MetaGetReadinessErrors, ThrowOnError>({
    responseValidator: async (data) => await zMetaGetReadinessResponse.parseAsync(data),
    url: '/readyz',
    ...options
});
